<template>
  <div>

     <!-- Notification Banners Section -->
     <div v-if="activeBanners && activeBanners.length > 0" class="px-4 pt-4">
      <div 
        v-for="banner in activeBanners" 
        :key="banner._id"
        :class="getBannerClass(banner.type)"
        class="mb-3 p-4 rounded-lg shadow-md flex items-start"
      >
        <div class="flex-shrink-0 mr-3">
          <i :class="getBannerIcon(banner.type)" class="text-xl"></i>
        </div>
        <div class="flex-1">
          <h4 class="font-bold text-sm mb-1">{{ banner.title }}</h4>
          <div v-html="banner.message" class="text-sm opacity-90"></div>
        </div>
        <button 
          @click="dismissBanner(banner._id)"
          class="ml-3 opacity-70 hover:opacity-100 transition-opacity"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

  <div class="relative pb-4 pt-6" v-if="currentUser && currentUser.type && currentUser.type && currentUser.role && $f.getPermission(currentUser,'dashboard')">
    <div class="mx-auto w-full home-dash">
      <div>
        <!-- Welcome banner -->
        <div class="welcome-banner">
          <div class="welcome-content">
            <h2 class="welcome-title">Welcome back, {{ currentUser.fullName || 'User' }}!</h2>
            <p class="welcome-subtitle">Here's what's happening with your business today.</p>
            <div class="welcome-stats">
              <div class="welcome-stat">
                <span v-if="loadingWelcome" class="welcome-stat-skeleton"></span>
                <span v-else class="welcome-stat-value">{{ welcomeData.totalOrders }}</span>
                <span class="welcome-stat-label">Today's Orders</span>
              </div>
              <div class="welcome-stat-divider"></div>
              <div class="welcome-stat">
                <span v-if="loadingWelcome" class="welcome-stat-skeleton"></span>
                <span v-else class="welcome-stat-value">{{ welcomeData.confirmRate }}%</span>
                <span class="welcome-stat-label">Confirm Rate</span>
              </div>
            </div>
          </div>
          <div class="welcome-img">
            <img src="https://cdn.dribbble.com/users/1162077/screenshots/3848914/programmer.gif" alt="Welcome" />
          </div>
        </div>

        <!-- Card stats -->
        <div class="flex flex-wrap">
             <div v-if="(currentUser.type=='Admin' || currentUser.type=='Seller')" class="w-full lg:w-1/3 md:w-1/2 xl:w-1/4  px-4 mb-4 box——1">
                 <card-stats-v2  
                    statSubtitle="Profit Net En Cours"
                    statSubtitle1="Generate"
                    :datas="AccountingRate"
                    :dataChart="AccountingRate.data"
                    :statTitle="TotalOrder"
                    :currency="idWharhouse?idWharhouse.currency:''"
                    id="chart1"
                    action="PendingRevenu"
                    @Refrechdata="Refrechdata"
                    refresh="true"
                    :timeserch="timeserchaccounting"
                    :loading="loadingaccounting"
                    statPercentColor="text-green-500"
                    statIconName="monetization_on"
                    statIconColor="bg-indigo-500"
                    color="#667eea"
                 />
             </div>
             <div class="w-full lg:w-1/3 md:w-1/2 xl:w-1/4  px-4 mb-4 box——1">
                 <card-stats-v2  
                    statSubtitle="Confirmation Rate"
                    :statTitle="TotalOrder"
                    :datas="ConfirmationRateAll"
                    :dataChart="ConfirmationRateAll.data"
                    :loading="loadingconfirmRate"
                    :timeserch="timeserchconfirmRate"
                    :idWharhouse="idWharhouse"
                    filter="true"
                    filterseller="true"
                    refresh="true"
                     currency="%"
                     id="chart2"
                     action="ConfirmationRate"
                    :seller="seller_confirmRate"
                    :product="product_confirmRate"
                    @ChangeDateConfirmationRate="ChangeTypeDateRevenuHeader"
                    @FindRecordsSellers="FindRecordsSellers"
                    @getUsersDebance="getUsersDebance"
                    @getProducts="getProducts"
                    @CheckSellerProducts="CheckSellerProducts"
                     @FindRecordsBetweenDate="FindRecordsHeader"
                     :from="from_ConfirmationRate"
                    :to="to_ConfirmationRate"
                    @removedata="removedata"
                    :sellers="sellers"
                    :currentUser="currentUser"
                    :products="products"
                    @Refrechdata="Refrechdata"
                    statPercentColor="text-green-500"
                    statIconName="timeline"
                    statIconColor="bg-green-500"
                    color="#48bb78"
                 />
             </div>
             <div class="w-full lg:w-1/3 md:w-1/2 xl:w-1/4  px-4 mb-4 box——1">
                 <card-stats-v2  
                    statSubtitle="Delivery Rate"
                     :datas="DeliveryRateAll"
                     @ChangeDateConfirmationDelevry="ChangeTypeDateRevenuHeader"
                     @FindRecordsSellers="FindRecordsSellers"
                     @getUsersDebance="getUsersDebance"
                     @getProducts="getProducts"
                     @CheckSellerProducts="CheckSellerProducts"
                      @FindRecordsBetweenDate="FindRecordsHeader"
                     :from="from_DeliveryRate"
                     :to="to_DeliveryRate"
                     @removedata="removedata"
                     :sellers="sellers"
                      :currentUser="currentUser"
                     :products="products"
                     @Refrechdata="Refrechdata"
                     :idWharhouse="idWharhouse"
                     :dataChart="DeliveryRateAll.data"
                     :statTitle="TotalOrder"
                     :loading="loadingdelivery"
                     :timeserch="timeserchdelivry"
                     :seller="seller_deliveryRate"
                     :product="product_deliveryRate"
                     action="Delivery"
                     refresh="true"
                     filterseller="true"
                     filter="true"
                     currency="%"
                     id="chart3"
                     statPercentColor="text-green-500"
                     statIconName="delivery"
                     statIconColor="bg-orange-500" 
                     color="#ed8936"
                 />
             </div>
             <div v-if="(currentUser.type=='Admin' || currentUser.type=='Seller')" class="w-full lg:w-1/3 md:w-1/2 xl:w-1/4  px-4 mb-4 box——1">
                 <card-stats-v2  
                    statSubtitle="Total Processed"
                    :datas="ProcessaidRate"
                    :dataChart="ProcessaidRate.data"
                     :loading="loadingprocessaid"
                    :currency="idWharhouse?idWharhouse.currency:''"
                     id="chart4"
                    statPercentColor="text-green-500"
                    statIconName="monetization_on"
                    statIconColor="bg-blue-500"
                    color="#4299e1"
                 />
             </div>
        </div> 
        <div class="flex flex-wrap">
             <div class="w-full lg:w-6/12 xl:w-2/3 px-4 mb-4 box——1">
                <card-stats-v3 
                     statSubtitle="Confirmation callcenter"
                    :dataChart="callcenterdata"
                    :loading="loadingcallcenter"
                    :label="labelCallcenter"
                    :timeserch="timeserchcallcenter"
                    @ChangeDateCallcenter="ChangeTypeDateRevenuHeader"
                    @FindRecordsBetweenDate="FindRecordsHeader"
                    @FindRecordsSellers="FindRecordsSellers"
                    :from="from_callcenter"
                    :to="to_callcenter"
                    :seller="seller_callcenter"
                    :product="product_callcenter"
                    id="chartp"
                    filter="true"
                    action="callcenter"
                    statPercentColor="text-green-500"
                    statIconName="imeline"
                    statIconColor="bg-green-500"
                    color="#48bb78"
                    @removedata="removedata"
                    :sellers="sellers"
                    :currentUser="currentUser"
                    :products="products"
                    @getUsersDebance="getUsersDebance"
                    @getProducts="getProducts"
                    @CheckSellerProducts="CheckSellerProducts"
                     filterseller="true"
                 />
               </div>
              <div class="w-full lg:w-6/12 xl:w-1/3 px-4 mb-4 box——1">
                <card-stats-v4 
                     statSubtitle="Overview status"
                    :dataChart="Confirmation"
                    :loading="loadingconfirm"
                    @ChangeDateConfirmation="ChangeTypeDateRevenuHeader"
                     @Refrechdata="Refrechdata"
                    @FindRecordsSellers="FindRecordsSellers"
                    :timeserch="timeserchconfirm"
                    :from="from_confirm"
                    :to="to_confirm"
                    :seller="seller_confirm"
                    :product="product_confirm"
                    id="charto"
                    filter="true"
                    refresh="true"
                    action="Confirmation"
                    statPercentColor="text-green-500"
                    statIconName="imeline"
                    statIconColor="bg-green-500"
                    color="#48bb78"
                    @FindRecordsBetweenDate="FindRecordsHeader"
                    @removedata="removedata"
                    :sellers="sellers"
                    :currentUser="currentUser"
                    :products="products"
                    @getUsersDebance="getUsersDebance"
                    @getProducts="getProducts"
                    @CheckSellerProducts="CheckSellerProducts"
                    filterseller="true"
                 />
             </div>
        </div> 
         <div class="flex flex-wrap">
             <div class="w-full lg:w-6/12 xl:w-1/3 px-4 mb-4 box——1">
                <card-stats-v5
                     statSubtitle="Shippings status"
                    :dataChart="datadelivery"
                    :loading="loadingDeliverystatu"
                    :timeserch="timeserchdelivery"
                    @ChangeDateDely="ChangeTypeDateDelivery"
                    @FindRecordsBetweenDate="FindRecordsHeader" 
                    @FindRecordsSellers="FindRecordsSellers"
                    :from="from_sh"
                    :to="to_sh"
                    :seller="seller_sh"
                    :product="product_sh"
                    id="chartshipp"
                    filter="true"
                    action="Delivry"
                    statPercentColor="text-green-500"
                    statIconName="imeline"
                    statIconColor="bg-green-500"
                    color="#48bb78"
                    @removedata="removedata"
                    :sellers="sellers"
                    :currentUser="currentUser"
                    :products="products"
                    @getUsersDebance="getUsersDebance"
                    @getProducts="getProducts"
                    @CheckSellerProducts="CheckSellerProducts"
                    filterseller="true"
                 />
              </div>
             <div v-if="(currentUser.type=='Admin' || currentUser.type=='Seller')" class="w-full lg:w-6/12 xl:w-2/3 px-4 mb-4 box——1">
              <card-stats-v6
                     statSubtitle="Trending products"
                    :dataChart="dataRevenusellerProducts"
                    :label="typedate"
                    :loading="loadingtopprduct"
                    :timeserch="timeserchtopproducts"
                    @ChangeDatetop="ChangeTypeDateRevenu"
                    @FindRecordsBetweenDate="FindRecordsHeader"
                    :currency="idWharhouse?idWharhouse.currency:''"
                    :from="from_top"
                    :to="to_top"
                    id="chartproducts"
                    filter="true"
                    action="topproducts"
                    statPercentColor="text-green-500"
                    statIconName="imeline"
                    statIconColor="bg-green-500"
                    color="#48bb78"
                    :currentUser="currentUser"
                    @removedata="removedata"
                    @getUsersDebance="getUsersDebance"
                    @CheckSellerProducts="CheckSellerProducts"
                    filterseller="true"
                    :seller="seller_top"
                    :sellers="sellers"
                 />
             </div>
            
         </div> 
        
         <div v-if="currentUser.type=='Admin'" class="flex flex-wrap">
             <div  class="w-full lg:w-6/12 xl:w-1/3 px-4 mb-4 box——1">
              <card-stats-v8
                     statSubtitle="Top Sellers by traits"
                    :dataChart="dataOrdersTopTraits"
                    :label="typedate"
                    :loading="loadingtotraits"
                    :timeserch="timeserchtoporderstraits"
                    @ChangeDatetop="ChangeTypeDateRevenu"
                    @FindRecordsBetweenDate="FindRecordsHeader"
                    :currency="idWharhouse?idWharhouse.currency:''"
                    :from="from_topTraits"
                    :to="to_topTraits"
                    id="charttraits"
                    filter="true"
                    action="toptraits"
                    statPercentColor="text-green-500"
                    statIconName="imeline"
                    statIconColor="bg-green-500"
                    color="#48bb78"
                    :currentUser="currentUser"
                    @removedata="removedata"
                    @getUsersDebance="getUsersDebance"
                    @CheckSellerProducts="CheckSellerProducts"
                    filterseller="true"
                    :seller="seller_topTraits"
                    :sellers="sellers"
                    :sortby_toptraits="sortby_toptraits"
                 />
             </div>
             <div class="w-full  lg:w-6/12 xl:w-1/3 px-4 mb-4 box——1">
                <card-stats-v6
                     statSubtitle="Top Sellers by Orders"
                    :dataChart="dataRevenuTopsellerOrders"
                    :label="typedate"
                    :loading="loadingtopsellersorders"
                    :timeserch="timeserchtopsellersorders"
                    @ChangeDatetop="ChangeTypeDateRevenu"
                    @FindRecordsBetweenDate="FindRecordsHeader"
                    :currency="idWharhouse?idWharhouse.currency:''"
                    :from="from_topSellers"
                    :to="to_topSellers"
                    id="chartproducts"
                    filter="true"
                    action="topsellersorders"
                    statPercentColor="text-green-500"
                    statIconName="imeline"
                    statIconColor="bg-green-500"
                    color="#48bb78"
                    :currentUser="currentUser"
                    @removedata="removedata"
                    @getUsersDebance="getUsersDebance"
                    @CheckSellerProducts="CheckSellerProducts"
                    filterseller="true"
                    :seller="seller_topSellers"
                    :sellers="sellers"
                 />
            </div>
         </div>

          <!-- <div class="flex flex-wrap">
               <div class="w-full lg:w-1/3 md:w-1/2 xl:w-1/4  px-4 mb-4 box——1">
                 <card-stats-v7  
                    statSubtitle="Total Products"
                    :datas="TotalProduct"
                    :loading="loadingproducts"
                    statPercentColor="text-green-500"
                    statIconName="local_mall"
                    statIconColor="bg-blue-500"
                    color="#4299e1"
                    trending="trending_up"
                    bg_color="gradient-deepblue"
                 />
              </div>
              <div v-if="(currentUser.type=='Admin' || currentUser.type=='Seller')" class="w-full lg:w-1/3 md:w-1/2 xl:w-1/4  px-4 mb-4 box——1">
                 <card-stats-v7  
                    statSubtitle="Total Revenue"
                    :datas="currentUser.type=='Seller'?TotalRevenue:{sum:'0.0',since:0}"
                    :loading="loadingprocessaid"
                    :currency="idWharhouse?idWharhouse.currency:''"
                    statPercentColor="text-green-500"
                    statIconName="attach_money"
                    statIconColor="bg-blue-500"
                    color="#4299e1"
                    trending="trending_up"
                    bg_color="gradient-orange"
                 />
              </div>
               <div v-if="(currentUser.type=='Admin' || currentUser.type=='Seller')" class="w-full lg:w-1/3 md:w-1/2 xl:w-1/4  px-4 mb-4 box——1">
                 <card-stats-v7  
                    statSubtitle="Total Processed"
                    :datas="currentUser.type=='Seller'?ProcessaidRate:{sum:'0.0',since:0}"
                    :loading="loadingprocessaid"
                    :currency="idWharhouse?idWharhouse.currency:''"
                    statPercentColor="text-green-500"
                    statIconName="attach_money"
                    statIconColor="bg-blue-500"
                    color="#4299e1"
                    trending="trending_up"
                    bg_color="gradient-ohhappiness"
                 />
              </div>
              <div class="w-full lg:w-1/3 md:w-1/2 xl:w-1/4  px-4 mb-4 box——1">
                 <card-stats-v7  
                    statSubtitle="Total Orders"
                    :datas="TotalOrder"
                    :loading="loadingorders"
                    statPercentColor="text-green-500"
                    statIconName="local_grocery_store"
                    statIconColor="bg-blue-500"
                    color="#4299e1"
                    trending="trending_up"
                    bg_color="gradient-ibiza"
                 />
              </div>
          </div>  -->

      <!--  <div class="flex flex-wrap">
          <div class="w-full lg:w-6/12 xl:w-4/12 px-4 mb-4">
            <card-stats
              statSubtitle="Total orders"
              :statTitle="TotalOrder"
              statArrow="up"
               filter="true"
               action="Orders"
              :timeserch="timeserchorders"
              :loading="loadingorders"
              :from="from_orders"
              :to="to_orders"
              statPercentColor="text-green-500"
              statIconName="local_grocery_store"
              statIconColor="bg-indigo-500"
              @ChangeTypeDateRevenu="ChangeTypeDateRevenuHeader"
              @FindRecords="FindRecordsHeader"
            />
          </div>
          <div
            v-if="currentUser.type == 'Admin' || ($f.getAccessPermission(currentUser,'analytics','read') && currentUser.type != 'Seller')"
            class="w-full lg:w-6/12 xl:w-4/12 px-4 mb-4"
          >
            <card-stats
              statSubtitle="Total Sellers"
              :statTitle="TotalSeller"
              statArrow="down"
              statPercentColor="text-red-500"
              statIconName="people"
              statIconColor="bg-yellow-500"
            />
          </div>
         <div
            v-if="currentUser.type == 'Seller' || currentUser.type == 'Admin' || $f.getAccessPermission(currentUser,'analytics','read')"
            class="w-full lg:w-6/12 xl:w-4/12 px-4 mb-4"
          >
            <card-stats
              statSubtitle="Total Products"
              :statTitle="TotalProduct"
              statArrow="down"
              statPercentColor="text-red-500"
              statIconName="local_mall"
              statIconColor="bg-orange-500"
            />
          </div>-->
          <!-- <div
            v-if="currentUser.type == 'Seller' || currentUser.type == 'Admin' || $f.getAccessPermission(currentUser,'analytics','read')"
            class="w-full lg:w-3/4 px-4 mb-4"
          >
            <card-stats
              statSubtitle="Total Sales"
              :statTitle="TotalOrdersPaid"
              statArrow="down"
              currency="true"
              action="Paid"
              :loading="loadingsales"
              filter="true"
              :timeserch="timeserchsales"
              :count="countOrdersPaid"
              :from="from_paid"
              :to="to_paid"
              countText="Orders"
              statPercentColor="text-red-500"
              statIconName="attach_money"
              statIconColor="bg-indigo-500"
              @ChangeTypeDateRevenu="ChangeTypeDateRevenuHeader"
              @FindRecords="FindRecordsHeader"
            />
          </div> -->
           <!-- <div
            v-if="currentUser.type == 'Seller' || currentUser.type == 'Admin' || $f.getAccessPermission(currentUser,'analytics','read')"
            class="w-full lg:w-3/4 px-4 mb-4"
          >
            <card-stats
              statSubtitle="Total REVENUES"
              :statTitle="TotalOrdersNotProcessed"
              statArrow="down"
              currency="true"
              :loading="loadingrevenu"
              filter="true"
              action="Processed"
              :timeserch="timeserchrevenues"
              :from="from_revenues"
              :to="to_revenues"
              :count="countOrdersProcessed"
               countText="Orders"
              statPercentColor="text-red-500"
              statIconName="monetization_on"
              statIconColor="bg-yellow-500"
              @ChangeTypeDateRevenu="ChangeTypeDateRevenuHeader"
              @FindRecords="FindRecordsHeader"
            />
          </div>
          <div
            v-if="currentUser.type == 'Seller' || currentUser.type == 'Admin' || $f.getAccessPermission(currentUser,'analytics','read')"
            class="w-full lg:w-3/4 px-4 mb-4"
          >
            <card-stats
              statSubtitle="Pending Sales"
              :statTitle="TotalOrdersPendingPaid"
              statArrow="down"
              currency="true"
              action="Paid"
              :timeserch="timeserchsales"
              :count="countOrdersPendingPaid"
               countText="Orders"
              statPercentColor="text-red-500"
              statIconName="attach_money"
              statIconColor="bg-indigo-500"
              @ChangeTypeDateRevenu="ChangeTypeDateRevenuHeader"
            />
          </div>
           <div
            v-if="currentUser.type == 'Seller' || currentUser.type == 'Admin' || $f.getAccessPermission(currentUser,'analytics','read')"
            class="w-full lg:w-3/4 px-4 mb-4"
          >
            <card-stats
              statSubtitle="Pending REVENUES"
              :statTitle="TotalOrdersPendingProcessed"
              statArrow="down"
              currency="true"
              action="Processed"
              :timeserch="timeserchrevenues"
              :count="countOrdersPendingProcessed"
               countText="Orders"
              statPercentColor="text-red-500"
              statIconName="monetization_on"
              statIconColor="bg-yellow-500"
              @ChangeTypeDateRevenu="ChangeTypeDateRevenuHeader"
            />
          </div> -->
         
          <!--  <div class="w-full lg:w-6/12 xl:w-4/12 px-4 mb-4">
            <card-stats
              statSubtitle="Confirmation"
              titleRate="Confirmation Rate:"
              :datas="Confirmation"
              :rate="ConfirmationRate"
              statArrow="up"
               filter="true"
               action="Confirmation"
              :timeserch="timeserchconfirm"
              :loading="loadingconfirm"
              :from="from_confirm"
              :to="to_confirm"
              statPercentColor="text-green-500"
              statIconName="timeline"
              statIconColor="bg-indigo-500"
              @ChangeTypeDateRevenu="ChangeTypeDateRevenuHeader"
              @FindRecords="FindRecordsHeader"
            />
          </div>
            <div class="w-full lg:w-6/12 xl:w-4/12 px-4 mb-4">
            <card-stats
              statSubtitle="Delivery"
              titleRate="Delivery Rate:"
              :datas="Delivery"
              :rate="DeliveryRate"
              statArrow="up"
               filter="true"
               action="Delivery"
              :timeserch="timeserchdelivry"
              :loading="loadingdelivery"
              :from="from_delivery"
              :to="to_delivery"
              statPercentColor="text-green-500"
              statIconName="timeline"
              statIconColor="bg-indigo-500"
              @ChangeTypeDateRevenu="ChangeTypeDateRevenuHeader"
              @FindRecords="FindRecordsHeader"
            />
          </div>
             <div v-if="currentUser.type == 'Seller' || currentUser.type == 'Admin' || ($f.getAccessPermission(currentUser,'analytics','read') && currentUser.type != 'Administrateur')" class="w-full lg:w-6/12 xl:w-4/12 px-4 mb-4">
            <card-stats
              statSubtitle="Accounting"
              :datasAcounting="Accounting"
               statArrow="up"
               filter="true"
               action="Accounting"
              :timeserch="timeserchaccounting"
              :loading="loadingaccounting"
              :from="from_accounting"
              :to="to_accounting"
              statPercentColor="text-red-500"
              statIconName="monetization_on"
              statIconColor="bg-yellow-500"
              @ChangeTypeDateRevenu="ChangeTypeDateRevenuHeader"
              @FindRecords="FindRecordsHeader"
            />
          </div>
           <div
            v-if="currentUser.type == 'Admin' || ($f.getAccessPermission(currentUser,'analytics','read') && currentUser.type != 'Seller' && currentUser.type != 'Administrateur')"
            class="w-full lg:w-6/12 xl:w-4/12 px-4 mb-4"
          >
            <card-stats
              statSubtitle="Shipsen Fees"
              :statTitle="Revenue"
              currency="true"
              statArrow="down"
              statPercentColor="text-red-500"
              statIconName="monetization_on"
              statIconColor="bg-orange-500"
            />
          </div>
           <div
           v-if="currentUser.type == 'Seller' || currentUser.type == 'Admin' || ($f.getAccessPermission(currentUser,'analytics','read') && currentUser.type != 'Administrateur')"
            class="w-full lg:w-6/12 xl:w-4/12 px-4 mb-4"
          >
            <card-stats 
              statSubtitle="Expedition fees paid"
              :statTitle="FeesExpeditions"
              :count="countExpeditions"
              countText="Expeditions"
              currency="true"
              statArrow="down"
              statPercentColor="text-red-500"
              statIconName="monetization_on"
              statIconColor="bg-orange-500"
            />
          </div>
        </div>-->
      </div>
    </div>
  </div>
     <!-- <div class="flex flex-wrap p-2">
   <div
        class="w-full"
        v-if="currentUser.type == 'Admin' || currentUser.type == 'Seller' || ($f.getAccessPermission(currentUser,'analytics','read') && currentUser.type != 'Administrateur')"
      >
        <chart-revenus
          :chartData="dataRevenu"
          :chartData1="dataRevenuOrders"
          :sumrevenuorder="sumrevenuorder"
          :sumrevenus="sumrevenus"
          :Labels="labelsrevenu"
          :label="labelRevenu"
          :countOrders="countOrders"
          filter="true"
          :from="from_r"
          :to="to_r"
          :title="'Revenus'"
          action="revenu"
          type="line"
          id="revenu-chart"
          :timeserch="timeserch"
          :userType="currentUser.type"
          :timeserchseller="timeserchseller"
          :labelstring="labelrevenuString"
          @ChangeTypeDateRevenu="ChangeTypeDateRevenuHeader"
          @ChangeSeller="ChangeSeller"
          @FindRecordRevenus="FindRecordRevenus"
        />
      </div>
      <div v-if="currentUser.type == 'Admin' || ($f.getAccessPermission(currentUser,'analytics','read') && currentUser.type != 'Seller')" class="w-full md:w-1/2 xl:w-1/2">
        <card-bar-chart
          :chartData="dataAllSeller"
           filter="true"
          :count="countSellers"
          :title="'Total Registrants '"
          type="doughnut"
          id="seller-chart"
          :timeserch="timeserchs"
          :userType="currentUser.type"
          :labelstring="labelAllsellerString"
          @ChangeTypeDateAllSeller="ChangeTypeDateAllSeller"
          @FindRecordSellers="FindRecordSellers"
        />
      </div>
      <div
        class="w-full md:w-1/2 xl:w-1/2"
        v-if="currentUser.type == 'Admin' || currentUser.type == 'Seller' || $f.getAccessPermission(currentUser,'analytics','read')"
      >
        <chart-status-orders
          :chartData="dataconfirmation"
          :count="countConfirmations"
           filter="true"
          :title="'Confirmation Status'"
          type="pie"
          id="confirmation-chart"
          :timeserch="timeserchc"
          :userType="currentUser.type"
          :timeserchseller="timeserchsellerconfirmation"
          :labelstring="labelconfirmationString"
          @ChangeTypeDateConfirmation="ChangeTypeDateConfirmation"
          @ChangeSellerConfirmation="ChangeSellerConfirmation"
          @FindRecordconfirmations="FindRecordconfirmations"
        />
      </div>
     
     <div
        class="w-full md:w-1/2 xl:w-1/2"
        v-if="currentUser.type == 'Admin' || currentUser.type == 'Seller' || $f.getAccessPermission(currentUser,'analytics','read')"
      >
        <chart-revenus
          :chartData="dataRevenusellerProducts"
          :Labels="labelsrevenusellerProducts"
          :label="label"
          :title="'Top products by orders'"
          type="bar"
          id="topproducts-chart"
          :userType="currentUser.type"
          :timeserchseller="timeserchsellerproduct"
          :timeserch="timeserchtopproducts"
          action="topproducts"
          :labelstring="labelrevenuStringtopproduct"
          @ChangeTypeDateRevenu="ChangeTypeDateRevenu"
          @ChangeSeller="ChangeSellerOrderProduct"
        />
      </div>
     
      <div
        class="w-full md:w-1/2 xl:w-1/2"
        v-if="currentUser.type == 'Admin' || currentUser.type == 'Seller' || $f.getAccessPermission(currentUser,'analytics','read')"
      >
        <chart-delivery
          :datadelivery="datadelivery"
          :count="totalShippings"
          :from="from_sh"
          :to="to_sh"
          filter="true"
          :titledelivery="'Shippings status'"
          typedelivery="pie"
          iddelivery="delivery-chart"
          :timeserchd="timeserchd"
          :userTypedelivery="currentUser.type"
          :timeserchsellerdelivery="timeserchsellerdelivery"
          :labelstringd="labeldeliveryString"
          @ChangeTypeDateDelivery="ChangeTypeDateDelivery"
          @ChangeSellerDelivery="ChangeSellerDelivery"
          @FindRecordShippings="FindRecordShippings"
        />
      </div>
    </div>-->

    <!--<div
      v-if="currentUser.type == 'Admin' || currentUser.type == 'Seller' || $f.getAccessPermission(currentUser,'analytics','read')"
      class="p-6"
    >
      <chart-orders
        :dataorders="dataorders"
        :titleorders="'Total Orders'"
        :from="from_o"
        :to="to_o"
        filter="true"
        typeorders="line"
        idorders="orders-chart"
        :timesercho="timesercho"
        :userTypeorders="currentUser.type"
        :timeserchsellerorders="timeserchsellerorders"
        :labelstringo="labelordersString"
        :Labels="labels"
        @ChangeTypeDateOrders="ChangeTypeDateOrders"
        @ChangeSellerOrders="ChangeSellerOrders"
        @FindRecordOrders="FindRecordOrders"
      />
    </div>--> 
  </div>
</template>

<script>
import CardStats from "@/components/Cards/CardStats.vue";
import CardStatsV2 from "@/components/Cards/CardStatsV2.vue";
import CardStatsV3 from "@/components/Cards/CardStatsV3.vue";
import CardStatsV4 from "@/components/Cards/CardStatsV4.vue";
import CardStatsV5 from "@/components/Cards/CardStatsV5.vue";
import CardStatsV6 from "@/components/Cards/CardStatsV6.vue";
import CardStatsV7 from "@/components/Cards/CardStatsV7.vue";
import CardStatsV8 from "@/components/Cards/CardStatsV8.vue";

import CardBarChart from "@/components/Analytics/Cards/CardBarChart.vue";
import HeaderFilters from "@/components/Analytics/Cards/HeaderFilters.vue";
import ChartOrders from "@/components/Analytics/Cards/ChartOrders.vue";
import ChartRevenus from "@/components/Analytics/Cards/ChartRevenu.vue";
import ChartStatusOrders from "@/components/Analytics/Cards/ChartStatusOrders.vue";
import ChartDelivery from "@/components/Analytics/Cards/ChartDelivery.vue";

export default {
  name: "dashboard-page",
  components: {
    ChartRevenus,
    CardBarChart,
    HeaderFilters,
    ChartOrders,
    ChartStatusOrders,
    ChartDelivery,
    CardStats,CardStatsV2,CardStatsV3,CardStatsV4,CardStatsV5,CardStatsV6,CardStatsV7,CardStatsV8
  },
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
     sous_idWharhouse: { type: String},
     sous_warehouses: { type: Array},
   },
  data() {
    return {
      token: null,
      formData: {
        startDate: "",
        endDate: "",
      },
      tab: [],
      //Revenu
      dataRevenu: [],
      dataRevenuOrders: [],
      sumrevenuorder:0,
      sumrevenus:0,
      countOrders:0,
      from_r:null,
      to_r:null,
      dataRevenusellerProducts: [],
      dataRevenuTopsellerOrders:[],
      dataOrdersTopTraits:{series:[],sellers:[]},
      dataStock: [],
      dataExp: [],
      dataExpFees: [],
      timeserch: "today",
      timeserchStock: "today",
      timeserchExp: "today",
      timeserchseller: "All",
      timeserchsellerExp: "All",
      timeserchsellerproduct: "All",
      timeserchtopproducts: "thisyear",
      timeserchtopsellersorders:"today",
      timeserchtoporderstraits: "today",
      timeserchtockhistoriesproducts: "...",
      timeserchstockhistoriesSeller: "All",
      labelsMonths: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
      ],
      labels: [
        "00:00",
        "01:00",
        "02:00",
        "03:00",
        "04:00",
        "05:00",
        "06:00",
        "07:00",
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "20:00",
        "21:00",
        "22:00",
        "23:00",
      ],
      labelsrevenu: [],
      labelsrevenusellerProducts: [],
      labelsStock: [],
      labelsExp: [],
      labelString: "Hours",
      labelrevenuString: "Hours",
      labelStringStock: "Hours",
      labelStringExp: "Hours",
      labelrevenuStringtopproduct: "Products",
      duree: "",
      tabsellers: [],
      tabordersbystatus: [],
      products: [],
      //**************Dellivery ***************/
      timeserchd: "today",
      timeserchdelivery:"today",
      labeldeliveryString: "Days",
      datadelivery: [{name:"queued",count:0,gradient:"#e2e79d",colors:"#e2e97a"},{name:"prepared",count:0,gradient:"#2575fc",colors:"#6a11cb"},{name:"reprogrammed",count:0,gradient:"#1c1c1c",colors:"#000"},{name:"shipped",count:0,gradient:"#f7971e",colors:"#ffd200"},{name:"Shipped Daily",count:0,gradient:"#ef9a5e",colors:"#eb7d30"},{name:"received",count:0,gradient:"#4493d7",colors:"#137ad3"},{name:"paid",count:0,gradient:"#65c554",colors:"#23ad0a"},{name:"cancelled",count:0,gradient:"#e94d7d",colors:"#f12564"},{name:"processed",count:0,gradient:"#e505be",colors:"#bb07e9"}],
      timeserchsellerdelivery: "All",
      totalShippings:0,
      from_sh:null,
      to_sh:null,
      /**************ConfirmationStatus ************/
      timeserchc: "today",
      labelconfirmationString: "Days",
      dataconfirmation: [],
      timeserchsellerconfirmation: "All",
      countConfirmations:0,
      from_c:null,
      to_c:null,

      /****************All Seller ***************/
      timeserchs: "today",
      labelAllsellerString: "Days",
      dataAllSeller: [],
      countSellers:0,
      from_s:null,
      to_s:null,

      /****************Total Orders *************/
      timesercho: "today",
      labelordersString: "Hours",
      dataorders: [],
      timeserchsellerorders: "All",
      from_o:null,
      to_o:null,
      /****************Label Chart************* */
      label: new Date().getFullYear(),
      labelRevenu: "Shipsen Fees",
      labelExp: "Transport fees",
      /******************Header stat*******************/
      Confirmation:[{name:"pending",gradient:"#f7971e",colors:"#d13adf",percent:0},{name:"waiting",gradient:"#0072ff",colors:"#00c8ff",percent:0},{name:"unreached",gradient:"#cf7609",colors:"#e9ad63",percent:0},{name:"double",gradient:"#660901d4",colors:"#660901",percent:0},{name:"traits",gradient:"#8f50ff",colors:"#d13adf",percent:0},{name:"NB CALLS",gradient:"#cf7609",colors:"#e9ad63",percent:0},{name:"confirmed",gradient:"#cddc35",colors:"#08a50e",percent:0},{name:"cancelled",gradient:"#f1076f",colors:"#ff5447",percent:0}],
      ConfirmationRateAll:{rate: 0,confirmed:0,cancelled:0,countAll:0,data:[0,0,0,0]},
      ConfirmationRate:0,
      Delivery:[],
      DeliveryRateAll:{rate:0,paid:0, received:0,cancelled:0, processed:0, countAll:0,data:[0,0,0,0]},
      DeliveryRate:0,
      Accounting:[],
      AccountingRate:{sum:0,sum1:0,data:[0]},
      Processaid:[],
      ProcessaidRate:{sum:0,data:[0]},
      TotalOrder: {count:0,since:0},
      FeesExpeditions: "",
      TotalSeller: "",
      TotalProduct: {count:0,since:0},
      TotalRevenue: {sum:0,since:0},
      TotalOrdersPaid: "",
      TotalOrdersPendingPaid: "",
      TotalOrdersNotProcessed: "",
      TotalOrdersPendingProcessed:"",
      Revenue: "",
      countOrdersPaid: 0,
      countOrdersPendingPaid:0,
      countOrdersProcessed: 0,
      countExpeditions: 0,
      countOrdersPendingProcessed:0,
      timeserchsales:'all',
      timeserchorders:'all',
      timeserchrevenues:'all',
      timeserchconfirm:'...',
      timeserchconfirmRate:'...',
      timeserchdelivry:'...',
      timeserchaccounting:'...',
      timeserchprocessaid:'...',
      timeserchcallcenter:'Today',
      typedate:"month",
      from_orders:null,
      to_orders:null,
      from_paid:null,
      to_paid:null,
      from_revenues:null,
      to_revenues:null,
      from_confirm:null,
      to_confirm:null,
      from_delivery:null,
      to_delivery:null,
      from_DeliveryRate:null,
      to_DeliveryRate:null,
      from_accounting:null,
      to_accounting:null,
      from_callcenter:null,
      to_callcenter:null,
      from_top:null,
      to_top:null,
      from_topSellers:null,
      to_topSellers:null,
      from_topTraits:null,
      to_topTraits:null,
      from_ConfirmationRate:null,
      to_ConfirmationRate:null,
      loadingsales: false,
      loadingrevenu: false,
      loadingorders: false,
      loadingconfirm:true,
      loadingWelcome: true,
      welcomeData: { totalOrders: 0, confirmedOrders: 0, cancelledOrders: 0, confirmRate: 0 },
      loadingdelivery:false,
      loadingaccounting:false,
      loadingprocessaid:false,
      loadingcallcenter:true,
      loadingDeliverystatu:false,
      loadingtopprduct:false,
      loadingtopsellersorders:false,
      loadingproducts:false,
      loadingconfirmRate:false,
      loadingtotraits:false,
      callcenterdata:[[0],[0]],
      labelCallcenter:["00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19","20","21","22","23"],
      seller_confirm:null,
      product_confirm:null,
      seller_confirmRate:null,
      product_confirmRate:null,
      seller_deliveryRate:null,
      product_deliveryRate:null,
      seller_callcenter:null,
      product_callcenter:null,
      seller_sh:null,
      product_sh:null,
      seller_top:null,
      seller_topTraits:null,
      seller_topSellers:null,
      sellers:[],
      products:[],
      sellerSelected:null,
      sortby_toptraits:'',
      activeBanners: [],
      dismissedBanners: []
    };
  },
  computed: {
        warhouseSelected(){
            return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
        },
    }, 
  watch: { 
        'warhouseSelected': async function(oldVal, newVal) {
           
        },
        'idWharhouse': async function(oldVal, newVal) {
            this.idWharhouse=oldVal; 
            // Refetch banners and welcome stats when warehouse changes
            if (newVal) {
              await this.fetchActiveBanners();
              this.fetchWelcomeStats();
            }
            await this.getSellers();
            await this.CheckSellerProducts(this.currentUser,null,'seller');
            this.timeserchprocessaid=this.timeserchorders="all";
            this.timeserchaccounting=this.timeserchconfirmRate=this.timeserchdelivry=this.timeserchconfirm="...";
            this.timeserchd=this.timeserchdelivery=this.timeserch=this.timeserchtoporderstraits="today";this.timeserchtopproducts=this.timeserchtopsellersorders="today";
            this.timeserchcallcenter="Today";
            this.$Progress.start();
            this.datadelivery= [{name:"queued",count:0,gradient:"#e2e79d",colors:"#e2e97a"},{name:"prepared",count:0,gradient:"#2575fc",colors:"#6a11cb"},{name:"reprogrammed",count:0,gradient:"#1c1c1c",colors:"#000"},{name:"shipped",count:0,gradient:"#f7971e",colors:"#ffd200"},{name:"Shipped Daily",count:0,gradient:"#ef9a5e",colors:"#eb7d30"},{name:"received",count:0,gradient:"#4493d7",colors:"#137ad3"},{name:"paid",count:0,gradient:"#65c554",colors:"#23ad0a"},{name:"cancelled",count:0,gradient:"#e94d7d",colors:"#f12564"},{name:"processed",count:0,gradient:"#e505be",colors:"#bb07e9"}];
            this.Confirmation=[{name:"pending",gradient:"#f7971e",colors:"#d13adf",percent:0},{name:"waiting",gradient:"#0072ff",colors:"#00c8ff",percent:0},{name:"unreached",gradient:"#cf7609",colors:"#e9ad63",percent:0},{name:"double",gradient:"#660901d4",colors:"#660901",percent:0},{name:"traits",gradient:"#8f50ff",colors:"#d13adf",percent:0},{name:"NB CALLS",gradient:"#cf7609",colors:"#e9ad63",percent:0},{name:"confirmed",gradient:"#cddc35",colors:"#08a50e",percent:0},{name:"cancelled",gradient:"#f1076f",colors:"#ff5447",percent:0}]
            this.ConfirmationRateAll={rate: 0,confirmed:0,cancelled:0,countAll:0,data:[0,0,0,0]}
            this.ConfirmationRate=0
            this.Delivery=[]
            this.DeliveryRateAll={rate:0,paid:0, received:0,cancelled:0, processed:0, countAll:0,data:[0,0,0,0]}
            this.DeliveryRate=0
            this.Accounting=[]
            this.AccountingRate={sum:0,sum1:0,data:[0]}
            this.Processaid=[];
            this.ProcessaidRate={sum:0,data:[0]};
            this.TotalOrder= {count:0,since:0};
            this.TotalProduct= {count:0,since:0};
            this.TotalRevenue={sum:0,since:0};
            //await this.getTotalOrdersPaid({ Response: "PendingRevenu",DateType:this.timeserchaccounting });
            //await this.getTotalOrdersPaid({ Response: "ConfirmationRate",DateType:this.timeserchconfirmRate });
           // await this.getTotalOrdersPaid({ Response: "Delivery",DateType:this.timeserchdelivry });
           if(this.currentUser.type=='Admin' || this.currentUser.type=='Seller') await this.getTotalOrdersPaid({ Response: "Processaid",DateType:this.timeserchprocessaid });
            await this.getTotalOrdersTeleConsultant({ IntervaleDate: "Today"});
            //await this.getTotalOrdersPaid({ Response: "Confirmation",DateType:this.timeserchconfirm });
            await this.getTotalDelivery({DateType: this.timeserchdelivery,Seller: this.timeserchsellerdelivery,});
            //await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserchtopproducts,Sellerproduct: this.timeserchseller,action: "topproducts",});
            if(this.currentUser.type=='Admin' || this.currentUser.type=='Seller') await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserchtopproducts,action: "topproducts",});
            if(this.currentUser.type=='Admin'){
              await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserchtoporderstraits,seller: null,action: "toptraits",sortTopTraits:this.sortby_toptraits});
              await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserchtopsellersorders,seller: null,action: "topsellersorders",});
            } 
           // await this.getTotalOrdersPaid({ Response: "Orders",DateType:this.timeserchorders });
            //await this.getTotalOrdersPaid({ Response: "products" });
            //this.getTotalRevenus();
            this.$Progress.finish();
            this.labelsrevenu=this.labels;
        },
        'sous_idWharhouse': async function(oldVal, newVal) {
          this.sous_idWharhouse=oldVal;  
          this.timeserchdelivery=this.timeserchtopproducts=this.timeserchtopsellersorders="today";
          this.timeserchconfirmRate=this.timeserchdelivry=this.timeserchconfirm="...";
          this.$Progress.start();
          await this.getTotalOrdersTeleConsultant({ IntervaleDate: "Today"});
          await this.getTotalDelivery({DateType: this.timeserchdelivery,Seller: this.timeserchsellerdelivery,});
          if(this.currentUser.type=='Admin'){
              await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserchtoporderstraits,seller: null,action: "toptraits",sortTopTraits:this.sortby_toptraits});
              await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserchtopsellersorders,seller: null,action: "topsellersorders",});
          } 
         // await this.getTotalOrdersPaid({ Response: "Orders",DateType:this.timeserchorders });
          this.$Progress.finish();
      }
  },
  async mounted() {
    this.$store.dispatch("actionloadingpage",{loading:true});
    this.token = this.$jwtService.verifyToken();

    if (this.idWharhouse) {
      await this.fetchActiveBanners();
      this.fetchWelcomeStats();
    }
     
    //await this.getTotalFeesExpeditions();
    if(this.idWharhouse && this.currentUser && this.currentUser.type){
      if(!this.$f.getPermission(this.currentUser,'dashboard')){ 
        this.$store.dispatch("actionloadingpage",{loading:false});
        if(window.history.state) this.$router.back();
      }else{
          this.$Progress.start();
          await this.getSellers();
          await this.CheckSellerProducts(this.currentUser,null,'seller');
          this.$store.dispatch("actionloadingpage",{loading:false});
          //await this.getTotalOrdersPaid({ Response: "PendingRevenu",DateType:this.timeserchaccounting });
          // await this.getTotalOrdersPaid({ Response: "ConfirmationRate",DateType:this.timeserchconfirmRate });
          // await this.getTotalOrdersPaid({ Response: "Delivery",DateType:this.timeserchdelivry });
          if(this.currentUser.type=='Admin' || this.currentUser.type=='Seller') await this.getTotalOrdersPaid({ Response: "Processaid",DateType:this.timeserchprocessaid });
          await this.getTotalOrdersTeleConsultant({ IntervaleDate: "Today"});
         // await this.getTotalOrdersPaid({ Response: "Confirmation",DateType:this.timeserchconfirm });
          await this.getTotalDelivery({DateType: this.timeserchdelivery});
          if(this.currentUser.type=='Admin' || this.currentUser.type=='Seller') await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserchtopproducts,seller: null,action: "topproducts",});
          if(this.currentUser.type=='Admin'){
            await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserchtoporderstraits,seller: null,action: "toptraits",sortTopTraits:this.sortby_toptraits});
            await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserchtopsellersorders,seller: null,action: "topsellersorders",});
          } 
          //await this.getTotalOrdersPaid({ Response: "Orders",DateType:this.timeserchorders });
          //await this.getTotalOrdersPaid({ Response: "products" });
          //this.getTotalRevenus();
          this.$Progress.finish();
          this.labelsrevenu=this.labels;
      }
       
    }
    // await this.getTotalOrdersPaid({ Response: "Revenue" });
    // await this.getTotalSeller();

    // await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserch,Seller: this.timeserchseller,action: "revenu",});
    // await this.getRevenus_and_TopProducts_Stock({    DateType: this.timeserchExp,Seller: this.timeserchsellerExp,action: "expeditions",  });
   


    // await this.getConfirmationStatus({DateType: this.timeserchc,Seller: this.timeserchsellerconfirmation,});
    // if (this.currentUser.type != "Seller" )  await this.getAllSeller({DateType: this.timeserchs,});
    // await this.getOrders({DateType: this.timesercho,Seller: this.timeserchsellerorders,});

    // if (this.currentUser.type == "Seller") {
    //   const res = await this.$server.search("products", {seller: this.currentUser._id,});
    //   if (res.content.results) {this.products = res.content.results;
    //   } else this.products = [];
    // }
    
  },
  methods: {
    async fetchWelcomeStats() {
      if (this.currentUser && (this.currentUser.type === 'Admin' || this.currentUser.type === 'Seller')) {
        try {
          this.loadingWelcome = true;
          var res = await this.$server.getWelcomeStats("analytics", { warehouse: this.idWharhouse._id });
          if (res && res.content) {
            this.welcomeData = res.content;
          }
        } catch (e) {
          console.log('fetchWelcomeStats error:', e);
        } finally {
          this.loadingWelcome = false;
        }
      } else {
        this.loadingWelcome = false;
      }
    },
    async fetchActiveBanners() {
      if(this.currentUser.type == 'Seller'){
          try {
            const res = await this.$server.getActiveNotifications("settings", {
              warehouse: this.idWharhouse._id
            });
            if (res.content) {
              // Filter out dismissed banners
              const dismissed = this.getDismissedBanners();
              this.activeBanners = res.content.filter(b => !dismissed.includes(b._id));
            }
          } catch (error) {
            console.error("Error fetching banners:", error);
          }
      }
      },

      dismissBanner(bannerId) {
        this.activeBanners = this.activeBanners.filter(b => b._id !== bannerId);
        // Save to localStorage to remember dismissed banners
        const dismissed = this.getDismissedBanners();
        dismissed.push(bannerId);
        localStorage.setItem('dismissedBanners', JSON.stringify(dismissed));
      },

      getDismissedBanners() {
        try {
          return JSON.parse(localStorage.getItem('dismissedBanners') || '[]');
        } catch {
          return [];
        }
      },

      getBannerClass(type) {
        const classes = {
          info: 'bg-blue-500 text-white',
          warning: 'bg-yellow-500 text-white',
          success: 'bg-green-500 text-white',
          danger: 'bg-red-500 text-white'
        };
        return classes[type] || classes.info;
      },

      getBannerIcon(type) {
        const icons = {
          info: 'fas fa-info-circle',
          warning: 'fas fa-exclamation-triangle',
          success: 'fas fa-check-circle',
          danger: 'fas fa-exclamation-circle'
        };
        return icons[type] || icons.info;
      },
      async getSellers() {
       if(this.currentUser && this.currentUser.role && this.currentUser.role.name && this.currentUser.role.name != "Seller" && this.currentUser.type != "Seller") {
          const res = await this.$server.search("users", {type: "Seller",warehouses:this.idWharhouse._id,limit:10,});
          if (res.content.results) this.sellers = res.content.results;
          else this.sellers = [];
       }else this.sellers = [];
    },
    async CheckSellerProducts(seller=null,action,model){
      console.log('seller-------',seller)
      console.log('action-------',action)
       console.log('model-------',model)

       if(model && model=='sort'){
         // if(seller){
              if(action && action =="toptraits"){
                   this.sortby_toptraits=seller?seller.name:null;
                   const filters={action:action, DateType: this.timeserchtoporderstraits,seller:this.seller_topTraits?this.seller_topTraits._id||this.seller_topTraits:null,sortTopTraits:this.sortby_toptraits}
                  if(this.timeserchtoporderstraits=="betweendate") filters.dates={from:this.from_topTraits,to:this.to_topTraits};
                  await this.getRevenus_and_TopProducts_Stock(filters);
              }
         // }
        }
       
       if(model && model=='seller'){
          if(seller && seller._id){
              if(action && action =="Confirmation"){
                this.seller_confirm=seller;
                let filters={Response: action,DateType:this.timeserchconfirm,seller:this.seller_confirm?this.seller_confirm._id||this.seller_confirm:null};
                if(this.timeserchconfirm=="betweendate") filters.dates={from:this.from_confirm,to:this.to_confirm};
                await this.getTotalOrdersPaid(filters);
              }
              if(action && action =="ConfirmationRate"){
                this.seller_confirmRate=seller;
                 let filters={ Response: action,DateType:this.timeserchconfirmRate,seller:this.seller_confirmRate?this.seller_confirmRate._id||this.seller_confirmRate:null };
                if(this.timeserchconfirmRate=="betweendate") filters.dates={from:this.from_ConfirmationRate,to:this.to_ConfirmationRate};
                await this.getTotalOrdersPaid(filters);
              }
              if(action && action =="Delivery"){ 
                this.seller_deliveryRate = seller;
                let filters={ Response: action,DateType:this.timeserchdelivry,seller:this.seller_deliveryRate?this.seller_deliveryRate._id||this.seller_deliveryRate:null };
                if(this.timeserchdelivry=="betweendate") filters.dates={from:this.from_DeliveryRate,to:this.to_DeliveryRate};
                await this.getTotalOrdersPaid(filters);
              }
              if(action && action =="Delivry"){ 
                this.seller_sh = seller;
                let filters={DateType: this.timeserchdelivery,seller:this.seller_sh?this.seller_sh._id||this.seller_sh:null};
                if(this.timeserchdelivery=="betweendate") filters.dates={from:this.from_sh,to:this.to_sh};
                 await this.getTotalDelivery(filters);
              }
              if(action && action =="callcenter"){
                  this.seller_callcenter = seller;
                  const filters={ IntervaleDate: this.timeserchcallcenter,seller:this.seller_callcenter?this.seller_callcenter._id||this.seller_callcenter:null}
                  if(this.timeserchcallcenter=="betweendate") filters.dates={from:this.from_callcenter,to:this.to_callcenter};
                  await this.getTotalOrdersTeleConsultant(filters);
              }
              //
              if(action && action =="topproducts"){
                  this.seller_top = seller;
                  const filters={action:action, DateType: this.timeserchtopproducts,seller:this.seller_top?this.seller_top._id||this.seller_top:null}
                  if(this.timeserchtopproducts=="betweendate") filters.dates={from:this.from_top,to:this.to_top};
                  await this.getRevenus_and_TopProducts_Stock(filters);
              }
              if(action && action =="topsellersorders"){
                  this.seller_topSellers = seller;
                  const filters={action:action, DateType: this.timeserchtopsellersorders,seller:this.seller_topSellers?this.seller_topSellers._id||this.seller_topSellers:null}
                  if(this.timeserchtopsellersorders=="betweendate") filters.dates={from:this.from_topSellers,to:this.to_topSellers};
                  await this.getRevenus_and_TopProducts_Stock(filters);
              }
              if(action && action =="toptraits"){ 
                  this.seller_topTraits = seller;
                  const filters={action:action, DateType: this.timeserchtoporderstraits,seller:this.seller_topTraits?this.seller_topTraits._id||this.seller_topTraits:null,sortTopTraits:this.sortby_toptraits}
                  if(this.timeserchtoporderstraits=="betweendate") filters.dates={from:this.from_topTraits,to:this.to_topTraits};
                  await this.getRevenus_and_TopProducts_Stock(filters);
              }
              this.sellerSelected=seller._id;
              this.products = [];
              if(action && action != "topproducts" && action != "toptraits" && action != "topsellersorders" || !action){
                const res = await this.$server.search("products", { 'details.warehouse':this.idWharhouse._id,seller: seller._id,limit:10 });
                if (res.content.results) {
                  this.products = res.content.results;
                } else this.products = [];
              }
            

         }else {this.sellerSelected=null;this.products = [];}
       }
        if(model && model=='product'){
              if(action && action =="Confirmation"){
                this.product_confirm=seller;
                let filters={ Response: action,DateType:this.timeserchconfirm,seller:this.seller_confirm?this.seller_confirm._id||this.seller_confirm:null,product:this.product_confirm?this.product_confirm._id||this.product_confirm:null };
                if(this.timeserchconfirm=="betweendate") filters.dates={from:this.from_confirm,to:this.to_confirm};
                await this.getTotalOrdersPaid(filters);
              }
             if(action && action =="ConfirmationRate"){
                this.product_confirmRate=seller;
                 let filters={ Response: action,DateType:this.timeserchconfirmRate,seller:this.seller_confirmRate?this.seller_confirmRate._id||this.seller_confirmRate:null,product:this.product_confirmRate?this.product_confirmRate._id||this.product_confirmRate:null };
                if(this.timeserchconfirmRate=="betweendate") filters.dates={from:this.from_ConfirmationRate,to:this.to_ConfirmationRate};
                await this.getTotalOrdersPaid(filters);
              }
              if(action && action =="Delivery"){
                this.product_deliveryRate=seller;
                let filters={ Response: action,DateType:this.timeserchdelivry,seller:this.seller_deliveryRate?this.seller_deliveryRate._id||this.seller_deliveryRate:null,product:this.product_deliveryRate?this.product_deliveryRate._id||this.product_deliveryRate:null };
                if(this.timeserchdelivry=="betweendate") filters.dates={from:this.from_DeliveryRate,to:this.to_DeliveryRate};
                await this.getTotalOrdersPaid(filters);
              }
              if(action && action =="Delivry"){ 
                this.product_sh = seller;
                let filters={DateType: this.timeserchdelivery,seller:this.seller_sh?this.seller_sh._id||this.seller_sh:null,product:this.product_sh?this.product_sh._id||this.product_sh:null};
                if(this.timeserchdelivery=="betweendate") filters.dates={from:this.from_sh,to:this.to_sh};
                 await this.getTotalDelivery(filters);
              }
              if(action && action =="callcenter"){
                this.product_callcenter = seller;
                let filters={ IntervaleDate: this.timeserchcallcenter,seller:this.seller_callcenter?this.seller_callcenter._id||this.seller_callcenter:null,product:this.product_callcenter?this.product_callcenter._id||this.product_callcenter:null};
                if(this.timeserchcallcenter=="betweendate") filters.dates={from:this.from_callcenter,to:this.to_callcenter};
                await this.getTotalOrdersTeleConsultant(filters);
              }
        }
      
    },
    getUsersDebance: _.debounce(async function(name) {
      console.log('name----',name)
      if(this.idWharhouse){
         if (this.currentUser && this.currentUser.role && this.currentUser.role.name && this.currentUser.role.name != "Seller" && this.currentUser.type != "Seller"){
             await this.$store.dispatch('wharhouse/searchUser',{type: "Seller",warhouse:this.idWharhouse._id,search:name}).then((res) => {this.sellers = res})
         }else this.sellers = [];
      }
   }, 500), 
    getProducts: _.debounce(async function(name) {
      console.log('event______________',name)
       const filter={seller: this.sellerSelected,warhouse:this.idWharhouse._id,search:name};
       console.log('filter______________',filter)
       if(this.sellerSelected) await this.$store.dispatch('wharhouse/searchProducts',filter).then((res) => {this.products = res;})
   }, 500), 
    async Refrechdata(action){
      if(action==="ConfirmationRate"){
          this.timeserchconfirmRate="today"
          await this.getTotalOrdersPaid({ Response: "ConfirmationRate",DateType:this.timeserchconfirmRate });
      }
      if(action==="Delivery"){
          this.timeserchdelivry="today"
          await this.getTotalOrdersPaid({ Response: "Delivery",DateType:this.timeserchdelivry });
      }
      if(action==="Confirmation"){
          this.timeserchconfirm="today"
          await this.getTotalOrdersPaid({ Response: "Confirmation",DateType:this.timeserchconfirm });
      }
      if(action==="PendingRevenu") {
        this.timeserchaccounting="all"
        await this.getTotalOrdersPaid({ Response: "PendingRevenu",DateType:this.timeserchaccounting });
         this.getTotalRevenus();
      }
    },
    getTotalRevenus(){
      this.TotalRevenue.sum=(parseFloat(this.ProcessaidRate.sum)+parseFloat(this.AccountingRate.sum)).toFixed(2);
      let since=0;
       if(this.ProcessaidRate.data.length>=3 && this.AccountingRate.data.length>=3){
            var arrMonthsP = this.ProcessaidRate.data.slice(Math.max(this.ProcessaidRate.data.length - 3, 0)); 
            var arrMonthsA = this.AccountingRate.data.slice(Math.max(this.AccountingRate.data.length - 3, 0)); 
            const a=arrMonthsP[0]+arrMonthsA[0];const b=arrMonthsP[1]+arrMonthsA[1];
            since=this.relDiff(a,b).toFixed();
            if(a>b) since=since * -1;
        }
      this.TotalRevenue.since=since;
    },
    async getwharhouseId(){
        await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    }, 
    relDiff(a, b){
       return a-b === 0 ? 0 : b>a ? 100 * Math.abs( (a - b) / b):100 * Math.abs( (b - a) / a);
    },
    async getTotalSeller() {
      const res = await this.$server.getTotalSeller("analytics");
      this.TotalSeller = res.content;
    },
    async getTotalFeesExpeditions() {
      const res = await this.$server.getTotalFeesExpeditions("analytics");
      this.FeesExpeditions = res.content.sum;
      this.countExpeditions = res.content.count;
    },
    async getTotalOrdersTeleConsultant(filters) {
        this.loadingcallcenter=true;
        filters.warehouse=this.idWharhouse._id;
        if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters['details.warehouseParent']=this.sous_idWharhouse;
        const res = await this.$server.getTotalOrdersTeleConsultant("analytics",filters);
        this.loadingcallcenter=false
        if(res && res.status == 200) {
          this.callcenterdata = res.content.resultat;
          if(res.content.lable) this.labelCallcenter=res.content.lable;
          if(res.content.countMonths && res.content.countMonths>1){
              for(let i in this.labelCallcenter){
                  this.labelCallcenter[i]=this.GetMonthName(this.labelCallcenter[i]);
              }
          }
        }  
        console.log('callcenterdata response---------',this.callcenterdata)
    },
    async getTotalOrdersPaid(filters) {
      console.log('filter response---------',filters.Response)
      let res;
      filters.warehouse=this.idWharhouse._id;
      console.log('warehouse---------',this.idWharhouse.country)
      switch (filters.Response) {
        case "Paid":
          this.loadingsales = true;
          res = await this.$server.getTotalOrdersPaid("analytics", filters);
          this.loadingsales = false;
          this.TotalOrdersPaid = res.content.sum;
          this.countOrdersPaid = res.content.count;
          break;
        case "PendingPaid":
          res = await this.$server.getTotalOrdersPaid("analytics", filters);
          this.TotalOrdersPendingPaid = res.content.sum;
          this.countOrdersPendingPaid = res.content.count;
          break;   
        case "Revenue":
          res = await this.$server.getTotalOrdersPaid("analytics", filters);
          this.Revenue = res.content.sum;
          break;
         case "Orders":
          this.loadingorders=true;
          if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters.warehouseParent=this.sous_idWharhouse;
          res = await this.$server.getTotalOrdersPaid("analytics", filters);
          this.TotalOrder = res.content;
          this.loadingorders=false;
          break;
        case "products":
          this.loadingproducts=true;
          res = await this.$server.getTotalOrdersPaid("analytics", filters);
          this.TotalProduct = res.content;
          this.loadingproducts=false;
          break;
        case "ConfirmationRate":  
         this.loadingconfirmRate=true;
         filters.seller=this.seller_confirmRate?this.seller_confirmRate._id||this.seller_confirmRate:null;
         filters.product=this.product_confirmRate?this.product_confirmRate._id||this.product_confirmRate:null;
         if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters.warehouseParent=this.sous_idWharhouse;
         res = await this.$server.getTotalOrdersPaid("analytics", filters);
         console.log('ConfirmationRate',res)
         if (res.content.ResultRateConfirm.length>0) {
                let countCon=0,countCan=0,countAll=0;
                res.content.ResultRateConfirm.forEach(x => {countCon +=  x.sumConfirmed;countCan +=  x.sumCancelled;countAll +=  x.count}); 
                var arrMonths = res.content.ResultRateConfirm.slice(Math.max(res.content.ResultRateConfirm.length - 10, 0)); 
                this.ConfirmationRateAll = {
                    rate:countAll!=0?((countCon/countAll)*100).toFixed(2):0,
                    confirmed:countCon,cancelled:countCan,countAll:countAll,
                    data:arrMonths.map( el => ((el.sumConfirmed/el.count)*100).toFixed(2))
                }
                //this.ConfirmationRate = (countCon+countCan)!=0?(countCon/(countCan+countCon))*100:0;
          } else {this.ConfirmationRateAll = {rate: 0,confirmed:0,cancelled:0,countAll:0,data:[0,0,0,0]}; this.ConfirmationRate = 0;}
          this.loadingconfirmRate=false;
        break;
        case "Confirmation":
          this.loadingconfirm=true;
          if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters.warehouseParent=this.sous_idWharhouse;
          res = await this.$server.getTotalOrdersPaid("analytics", filters);
          this.Confirmation = res.content.datas;
          var total = 0,totlC=0; this.Confirmation.forEach(item => {if(item.name=="Confirmed" || item.name=="Cancelled") total += item.count;});
          this.Confirmation.splice(4, 0, {name:"Traits",count:total});
          this.Confirmation.forEach(item => {if(item.name=="Waiting" || item.name=="Pending" || item.name=="Unreached" || item.name=="Double") totlC += item.count;});
          this.Confirmation.forEach(item => {
            //if(item.name=="OutOfStock" || item.name=="Pending" || item.name=="Unreached") item.percent=totlC!=0?(item.count*100/totlC).toFixed(0):0;
            if(item.name=="Confirmed" || item.name=="Cancelled") item.percent=total!=0?(item.count*100/total).toFixed(0):0;
            if(item.name=="Traits" || item.name=="NB CALLS") item.percent=(totlC+item.count!=0)?(item.count*100/(totlC+item.count)).toFixed(0):0;
            if(item.name=="Waiting") {item.percent=totlC!=0?(item.count*100/totlC).toFixed(0):0;item.gradient='#0072ff';item.colors="#00c8ff";}
            else if(item.name=="Pending") {item.percent=totlC!=0?(item.count*100/totlC).toFixed(0):0;item.gradient='#f7971e';item.colors="#ffd200";}
            else if(item.name=="Traits") {item.gradient='#8f50ff';item.colors="#d13adf";}
            else if(item.name=="Confirmed") {item.gradient='#cddc35';item.colors="#08a50e";} 
            else if(item.name=="NB CALLS") {item.gradient='#cf7609';item.colors="#e9ad63";}
            else if(item.name=="Unreached"){item.percent=totlC!=0?(item.count*100/totlC).toFixed(0):0;item.gradient="#cf7609";item.colors="#e9ad63"}
            else if(item.name=="Double"){item.percent=totlC!=0?(item.count*100/totlC).toFixed(0):0;item.gradient="#660901d4";item.colors="#660901"}
            else {item.gradient='#f1076f';item.colors="#ff5447";}
          });
          this.loadingconfirm=false;
          break;
        case "Delivery":
          this.loadingdelivery=true;
          filters.seller=this.seller_deliveryRate?this.seller_deliveryRate._id||this.seller_deliveryRate:null;
          filters.product=this.product_deliveryRate?this.product_deliveryRate._id||this.product_deliveryRate:null;
          if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters.warehouseParent=this.sous_idWharhouse;
          res = await this.$server.getTotalOrdersPaid("analytics", filters);
          console.log('res_Delivery_____',res.content)
          if (res.content.ResultRateDelivry.length>0) {
                let countPaid=0,countCancelled=0,countProcessed=0,countReceived=0,countAll=0;
                res.content.ResultRateDelivry.forEach(x => {countCancelled +=  x.sumCanceled;countProcessed +=  x.sumProcessed;countPaid +=  x.sumPaid;countReceived +=  x.sumReceived;countAll +=  x.count}); 
                var arrMonths = res.content.ResultRateDelivry.slice(Math.max(res.content.ResultRateDelivry.length - 10, 0)); 
                this.DeliveryRateAll = {
                    rate:(((countPaid+countReceived+countProcessed)/(countPaid+countReceived+countProcessed+countCancelled))*100).toFixed(2),
                    cancelled:countCancelled,processed:countProcessed,paid:countPaid, received:countReceived, countAll:countAll,
                    data:arrMonths.map( el => (((el.sumPaid+el.sumReceived+el.sumProcessed)/(el.sumPaid+el.sumReceived+el.sumProcessed+el.sumCanceled))*100).toFixed(2))
                }
          } else this.DeliveryRateAll = {rate: 0,paid:0, received:0,cancelled:0, processed:0, countAll:0,data:[0,0,0,0]}
          // this.Delivery = res.content.datas;
          // this.DeliveryRate = res.content.rate;
          // this.DeliveryRateAll = res.content.ResultRateDelivry;
          this.loadingdelivery=false;
          break;
        case "Processaid":
          this.loadingprocessaid=true;
          res = await this.$server.getTotalOrdersPaid("analytics", filters);
           
          this.Processaid = res.content.datas;
          this.ProcessaidRate = res.content.datas[0];
          if(this.ProcessaidRate.sum===0) this.ProcessaidRate.sum = this.ProcessaidRate.sum.toFixed(2)
          this.loadingprocessaid=false;
        break;  
        case "PendingRevenu":
          this.loadingaccounting=true;
          res = await this.$server.getTotalOrdersPaid("analytics", filters);
          this.Accounting = res.content.datas;
          this.AccountingRate=res.content.datas[0];
          this.loadingaccounting=false;
          break;
        default:
      }
    },
    async FindRecordsHeader(action,from,to) {
      let seller=null, product=null;
        if (action == "Paid") {
          this.from_paid = from;
          this.to_paid = to;
        } if (action == "Orders") {
           this.from_orders = from;
           this.to_orders = to;
        }if(action =="Processed") {
           this.from_revenues = from;
           this.to_confirm = to;
        }
        if(action =="Confirmation") {
          this.from_confirm = from;
          this.to_confirm = to;
          seller=this.seller_confirm;
          product=this.product_confirm;
        }
         if(action =="Delivry") {
           this.from_sh = from;
           this.to_sh = to;
           seller=this.seller_sh;
           product=this.product_sh;
        }
        if(action =="Accounting") {
           this.from_accounting = from;
           this.to_accounting = to;
        }
        if(action =="callcenter") {
           this.from_callcenter = from;
           this.to_callcenter = to;
           seller=this.seller_callcenter;
           product=this.product_callcenter;
        }
        if(action =="ConfirmationRate") {
           this.from_ConfirmationRate = from;
           this.to_ConfirmationRate = to;
           seller=this.seller_confirmRate;
           product=this.product_confirmRate;
        }
        if(action =="topproducts") {
           this.from_top = from;
           this.to_top = to;
           seller = this.seller_top;
        }
        if(action =="topsellersorders") {
           this.from_topSellers = from;
           this.to_topSellers = to;
           seller = this.seller_topSellers;
        }
        if(action =="toptraits") {
           this.from_topTraits = from;
           this.to_topTraits = to;
           seller = this.seller_topTraits;
        }
        if(action =="Delivery") {
           this.from_DeliveryRate = from;
           this.to_DeliveryRate = to;
           seller=this.seller_deliveryRate;
           product=this.product_deliveryRate;
        }
        console.log('action------',action)
       if(action!="callcenter"){
         if(action == "topproducts" || action == "toptraits" || action == "topsellersorders")   await this.getRevenus_and_TopProducts_Stock({DateType: 'betweendate',dates:{from:from.map( el => this.$moment(el).format('yyyy-MM-DD')),to:to},Response: action,action:action,seller:seller?seller._id||seller:null,sortTopTraits:this.sortby_toptraits});
         else if(action == "Delivry") await this.getTotalDelivery({DateType: 'betweendate',dates:{from:from.map( el => this.$moment(el).format('yyyy-MM-DD')),to:to},Response: action,seller:seller?seller._id||seller:null,product:product?product._id||product:null});
         else await this.getTotalOrdersPaid({DateType: 'betweendate',dates:{from:from.map( el => this.$moment(el).format('yyyy-MM-DD')),to:to},Response: action,seller:seller?seller._id||seller:null,product:product?product._id||product:null});
       }else await this.getTotalOrdersTeleConsultant({dates:{from:from.map( el => this.$moment(el).format('yyyy-MM-DD')),to:to}, IntervaleDate: "Two Date",seller:seller?seller._id||seller:null,product:product?product._id||product:null});
     },
     async FindRecordsSellers(action,seller,product) {
       console.log('action------',action)
        console.log('seller------',seller)
        if(action =="Confirmation") { 
          this.seller_confirm = seller;
          this.product_confirm = product;
          await this.getTotalOrdersPaid({ Response: "Confirmation",DateType:this.timeserchconfirm,seller:seller?seller._id||seller:null,product:product?product._id||product:null });
        }
         if(action =="Delivery") {
           this.seller_deliveryRate = seller;
           this.product_deliveryRate = product;
           await this.getTotalOrdersPaid({ Response: "Delivery",DateType:this.timeserchdelivry,seller:seller?seller._id||seller:null,product:product?product._id||product:null });
        }
        if(action =="Delivry") {
           this.seller_sh = seller;
           this.product_sh = product;
            await this.getTotalDelivery({DateType: this.timeserchdelivery,seller:seller?seller._id||seller:null,product:product?product._id||product:null});
        }
        if(action =="topproducts") {
           this.seller_top = seller;
            await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserchtopproducts,seller:seller?seller._id||seller:null});
        }
        if(action == "topsellersorders") {
           this.seller_topSellers = seller;
            await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserchtopsellersorders,seller:seller?seller._id||seller:null});
        }

        if(action =="toptraits") {
            this.seller_topTraits = seller;
            await this.getRevenus_and_TopProducts_Stock({DateType: this.timeserchtoporderstraits,seller:seller?seller._id||seller:null});
        }
        if(action =="ConfirmationRate") {
          console.log('is-confirmation rate')
           this.seller_confirmRate = seller;
           this.product_confirmRate = product;
           await this.getTotalOrdersPaid({ Response: "ConfirmationRate",DateType:this.timeserchconfirmRate,seller:seller?seller._id||seller:null,product:product?product._id||product:null });
        }
        if(action =="callcenter") {
           this.seller_callcenter = seller;
           this.product_callcenter = product;
           await this.getTotalOrdersTeleConsultant({ IntervaleDate: this.timeserchcallcenter,seller:seller,product:product});
        }
      
     },
    async removedata(action){
         if(action =="Delivery") {
           console.log('is---------------------',action)
           this.seller_deliveryRate = null;
           this.product_deliveryRate = null;
           let filters={DateType: this.timeserchdelivry,Response: action};
           if(this.timeserchdelivry=="betweendate") filters.dates={from:this.from_DeliveryRate,to:this.to_DeliveryRate};
           console.log('filter delivery-------',filters)
           await this.getTotalOrdersPaid(filters);
         }
         if(action =="Delivry") {
           this.seller_sh = null;
           this.product_sh = null;
           let filters={DateType: this.timeserchdelivery};
           if(this.timeserchdelivery=="betweendate") filters.dates={from:this.from_sh,to:this.to_sh};

           console.log('filter-------',filters)
            await this.getTotalDelivery(filters);
        }
        if(action =="ConfirmationRate") {
           this.seller_confirmRate = null;
           this.product_confirmRate = null;
           let filters={DateType: this.timeserchconfirmRate,Response: action};
           if(this.timeserchconfirmRate=="betweendate") filters.dates={from:this.from_ConfirmationRate,to:this.to_ConfirmationRate};
           await this.getTotalOrdersPaid(filters);
           
        }
        if(action =="callcenter") {
           this.seller_callcenter = null;
           this.product_callcenter = null;
           let filters={IntervaleDate: this.timeserchcallcenter};
           if(this.timeserchcallcenter=="betweendate") filters.dates={from:this.from_callcenter,to:this.to_callcenter};
           await this.getTotalOrdersTeleConsultant(filters);
        }
        if(action =="Confirmation") {
           this.seller_confirm = null;
           this.product_confirm = null;
           let filters={DateType: this.timeserchconfirm,Response: action};
           if(this.timeserchconfirm=="betweendate") filters.dates={from:this.from_confirm,to:this.to_confirm};
           await this.getTotalOrdersPaid(filters);
        }
        if(action =="topproducts") {
           this.seller_top = null;
           let filters={DateType: this.timeserchtopproducts,Response: action,action: action};
           if(this.timeserchtopproducts=="betweendate") filters.dates={from:this.from_top,to:this.to_top};
           await this.getRevenus_and_TopProducts_Stock(filters);
        }
        if(action =="topsellersorders") {
           this.seller_topSellers = null;
           let filters={DateType: this.timeserchtopsellersorders,Response: action,action: action};
           if(this.timeserchtopsellersorders=="betweendate") filters.dates={from:this.from_topSellers,to:this.to_topSellers};
           await this.getRevenus_and_TopProducts_Stock(filters);
        }
        if(action =="toptraits") {
            this.seller_topTraits = this.sortby_toptraits =  null;
           let filters={DateType: this.timeserchtoporderstraits,Response: action,action: action};
           if(this.timeserchtoporderstraits=="betweendate") filters.dates={from:this.from_topTraits,to:this.to_topTraits};
           await this.getRevenus_and_TopProducts_Stock(filters);
        }
     },
     async FindRecordRevenus(from,to) {
        this.labelsrevenu = [];
        this.dataRevenu = [];
        this.dataRevenuOrders = [];
        this.sumrevenuorder=this.sumrevenus=0;
          this.countOrders=0;
       this.from_r = from;
       this.to_r = to;

      await this.getRevenus_and_TopProducts_Stock({
        DateType: 'betweendate',
        dates:{from:from,to:to},
        action: 'revenu',
      });
     },
    async FindRecordShippings(action,from,to) {
       this.from_sh = from;
       this.to_sh = to;

      await this.getTotalDelivery({
        DateType:  'betweendate',
        seller:this.seller_sh?this.seller_sh._id||this.seller_sh:null,product:this.product_sh?this.product_sh._id||this.product_sh:null,
        dates:{from:from,to:to},
      });
     },
      async FindRecordOrders(from,to) {
       this.from_o = from;
       this.to_o = to;
       this.labelordersString = "Days";
       await this.getOrders({
        DateType:'betweendate',
        dates:{from:from,to:to},
        Seller: this.timeserchsellerorders,
      });
     },
     async FindRecordSellers(from,to) {
       this.from_s = from;
       this.to_s= to;

      await this.getAllSeller({
        DateType: 'betweendate',
        dates:{from:from,to:to},
      });
     },
     async FindRecordconfirmations(from,to) {
       this.from_c = from;
       this.to_c= to;

      await this.getConfirmationStatus({
        DateType: 'betweendate',
        dates:{from:from,to:to},
      });
     },
    async getProductById(id) {
      const result = await this.$server.get("products", { _id: id });
      // console.log('product_____', result.content)
      if (result.content) {
        var nom_product = result.content.name;
        if (nom_product && nom_product.length > 10)
          nom_product = nom_product.substring(0, 10) + "...";
        return nom_product;
      }
    },
    async getProductByIdV2(id) {
      const result = await this.$server.get("products", { _id: id });
       //console.log('product_____', result.content)
      if (result && result.content && result.content.seller && result.content.seller.fullName) {
        var nom_product = result.content.name;
        if (nom_product && nom_product.length > 10) nom_product = nom_product.substring(0, 25) + "...";
        return {name:nom_product,seller:result.content.seller.fullName};
      }else return {name:'',seller:''};
    },
    GetMonthName(monthNumber) {
      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months[monthNumber - 1];
    },
    getTymeType() {
      var type = "";
      if (this.timeserch == "today") {
        type = "hour";
      } else if (this.timeserch == "thisyear") {
        type = "month";
      } else {
        type = "day";
      }
      return type;
    },
    getTymeTypeStock() {
      var type = "";
      if (this.timeserchStock == "today") {
        type = "hour";
      } else if (this.timeserchStock == "thisyear") {
        type = "month";
      } else {
        type = "day";
      }
      return type;
    },
    getTymeTypeExp() {
      var type = "";
      if (this.timeserchExp == "today") {
        type = "hour";
      } else if (this.timeserchExp == "thisyear") {
        type = "month";
      } else {
        type = "day";
      }
      return type;
    },
    async ChangeTypeDateRevenu(event) {
      console.log('_event_______________',event.target.name)
      console.log('_event_______________',event.target.value)
      let seller=null, product=null;
      if (event.target.name == "revenu") {
        this.timeserch = event.target.value;
         if( event.target.value != "betweendate"){
            this.labelsrevenu = [];
            this.dataRevenu = [];
            this.dataRevenuOrders = [];
              this.countOrders=0;
            this.sumrevenuorder=this.sumrevenus=0;
            if (event.target.value == "today") {
              this.labelrevenuString = "Hours";
            } else if (event.target.value == "thisyear") {
              this.labelrevenuString = "Months";
            } else {
              this.labelrevenuString = "Days";
            }
         }else{
             this.labelrevenuString = "Days";
         }
      } else if (event.target.name == "stockhistories") {
        this.timeserchStock = event.target.value;
        this.labelsStock = [];
        this.dataStock = [];
        if (event.target.value == "today") {
          this.labelStringStock = "Hours";
        } else if (event.target.value == "thisyear") {
          this.labelStringStock = "Months";
        } else {
          this.labelStringStock = "Days";
        }
      } else if (event.target.name == "expeditions") {
        this.timeserchExp = event.target.value;
        this.labelsExp = [];
        this.dataExp = [];
        this.dataExpFees = [];
        if (event.target.value == "today") {
          this.labelStringExp = "Hours";
        } else if (event.target.value == "thisyear") {
          this.labelStringExp = "Months";
        } else {
          this.labelStringExp = "Days";
        }
      } else if (event.target.name == "topproducts") {
        this.timeserchtopproducts=event.target.value;
        seller=this.seller_top;
      
      }else if (event.target.name == "topsellersorders") {
        this.timeserchtopsellersorders=event.target.value;
        seller=this.seller_topSellers;
      
      }else if (event.target.name == "toptraits") {
        this.timeserchtoporderstraits=event.target.value;
        seller=this.seller_topTraits;
     }
      if( event.target.value != "betweendate"){
        console.log('valau___________________',event.target.value)
        await this.getRevenus_and_TopProducts_Stock({
          DateType: event.target.value,
          seller: seller?seller._id||seller:null,
          action: event.target.name,
        });
      }
    },
     getNumberOfDayinMonths(d) {
        let month = d.getMonth() + 1;
        let year = d.getFullYear();
        let nbr_jours = new Date(year, month, 0).getDate();
        let data=[];
        for (let i = 1; i <= nbr_jours; i++) {
              data.push(i);
        }
        return data;
    },
    async ChangeTypeDateRevenuHeader(event) {
        console.log('dtata valure',event.target.value)
        console.log('dtata name',event.target.name)
        let seller=null, product=null;
      if (event.target.name == "Paid") {
        this.timeserchsales = event.target.value;
      } if (event.target.name == "Orders") {
        this.timeserchorders = event.target.value;
      }if(event.target.name=="Processed") {
        this.timeserchrevenues = event.target.value;
      }if(event.target.name=="Confirmation") {
        this.timeserchconfirm = event.target.value;
         seller=this.seller_confirm;
        product=this.product_confirm;
      }if(event.target.name=="ConfirmationRate") {
        this.timeserchconfirmRate = event.target.value;
        seller=this.seller_confirmRate;
        product=this.product_confirmRate;
      }if(event.target.name=="Delivery") {
        this.timeserchdelivry = event.target.value;
        seller=this.seller_deliveryRate;
        product=this.product_deliveryRate;
      }if(event.target.name=="Accounting") {
        this.timeserchaccounting = event.target.value;
      }if(event.target.name=="callcenter") {
        this.timeserchcallcenter = event.target.value;
        seller=this.seller_callcenter;
        product=this.product_callcenter;
  
        if(this.timeserchcallcenter=='Today') this.labelCallcenter=[ "00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19","20","21","22","23",]
        if(this.timeserchcallcenter=='This Year') this.labelCallcenter=[ "January","February","March","April","May","June","July","August","September","October","November","December",];
        if(this.timeserchcallcenter=='This Month') this.labelCallcenter=this.getNumberOfDayinMonths(new Date());
        if(this.timeserchcallcenter=='Last Month') { let dl = new Date();dl.setMonth(dl.getMonth() - 1);this.labelCallcenter=this.getNumberOfDayinMonths(dl);}
         console.log('this.labelCallcenter',this.labelCallcenter)
      }

     console.log('this.timeserchconfirm',this.timeserchconfirm)
      
      if(event.target.value != "betweendate"){
        if(event.target.name!="callcenter")  await this.getTotalOrdersPaid({DateType: event.target.value,Response: event.target.name,seller:seller?seller._id||seller:null,product:product?product._id||product:null});
        else await this.getTotalOrdersTeleConsultant({ IntervaleDate: this.timeserchcallcenter,seller:seller?seller._id||seller:null,product:product?product._id||product:null});
      }
      
    },
    async ChangeSeller(seller) {
      this.timeserchseller = seller._id;
      this.dataRevenu = [];
      this.dataRevenuOrders = [];
      this.sumrevenuorder=this.sumrevenus=0;
        this.countOrders=0;
      this.labelsrevenu = [];
      await this.getRevenus_and_TopProducts_Stock({
        DateType: this.timeserch,
        Seller: this.timeserchseller,
        action: "revenu",
      });
    },
    async ChangeSellerExp(seller) {
      this.timeserchsellerExp = seller._id;
      this.dataExp = [];
      this.dataExpFees = [];
      this.labelsExp = [];
      await this.getRevenus_and_TopProducts_Stock({
        DateType: this.timeserchExp,
        Seller: this.timeserchsellerExp,
        action: "expeditions",
      });
    },
    async ChangeSellerStock(seller) {
      this.products = [];
      const res = await this.$server.search("products", { seller: seller._id });
      if (res.content.results) {
        this.products = res.content.results;
      } else this.products = [];
      this.timeserchstockhistoriesSeller = seller._id;
    },
    async ChangeProduct(product) {
      this.timeserchtockhistoriesproducts = product._id;
      this.dataStock = [];
      this.labelsStock = [];
      await this.getRevenus_and_TopProducts_Stock({
        DateType: this.timeserchStock,
        Product: this.timeserchtockhistoriesproducts,
        action: "stockhistories",
      });
    },
    async ChangeSellerOrderProduct(seller) {
      this.timeserchsellerproduct = seller._id;
      this.dataRevenusellerProducts = [];
      this.labelsrevenusellerProducts = [];
      await this.getRevenus_and_TopProducts_Stock({
        DateType: this.timeserchtopproducts,
        seller: this.seller_top._id||this.seller_top,
        action: "topproducts",
      });
    },
    async getUser() {
      const res = await this.$server.me("users");

      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
    },
    async getOrders(filters) {
      const res = await this.$server.getOrders("analytics", filters);
      this.tab = res.content;
    },
    async getRevenus_and_TopProducts_Stock(filters) {
      if (filters.action == "revenu") filters.Seller = this.timeserchseller;
      if (filters.action == "stockhistories") filters.SellerproductStock = this.timeserchstockhistoriesSeller;
      if(filters.action=="topproducts") this.loadingtopprduct=true;
      if(filters.action=="toptraits") this.loadingtotraits=true;
      if(filters.action=="topsellersorders") this.loadingtopsellersorders=true;

      filters.warehouse=this.idWharhouse._id;
      if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters.warehouseParent=this.sous_idWharhouse;
      console.log('filters getRevenus_and_TopProducts_Stock ----------',filters)
      const res = await this.$server.getRevenus_and_TopProducts_Stock("analytics",filters);
      if(filters.action=="topproducts") this.loadingtopprduct=false;
      if(filters.action=="toptraits") this.loadingtotraits=false;
      if(filters.action=="topsellersorders") this.loadingtopsellersorders=false;
      
      var nom_product = "";
      //
      if (res && res.content) {
        if(filters.action=="topproducts") {
          console.log('res topproducts ----------',res.content)
             // this.dataRevenusellerProducts=res.content.topProducts;
              if(res && res.content && res.content.topProducts.length>0){
                this.dataRevenusellerProducts=res.content.topProducts;
                //  for (const element of res.content.topProducts) {
                //         nom_product = await this.getProductByIdV2(element._id.productId);
                //        if(nom_product.name) this.dataRevenusellerProducts.push({name:nom_product.seller,data: [{y:element.totalSales ,name: nom_product.name}]})
                //  }
                  console.log('this.dataTopProducts----------',this.dataRevenusellerProducts)
             }else this.dataRevenusellerProducts=[];
              this.typedate=res.content.field;
        }else if(filters.action=="topsellersorders") {
             console.log('res topproducts ----------',res.content)
              if(res && res.content && res.content.topProducts.length>0){
                this.dataRevenuTopsellerOrders=res.content.topProducts;
                console.log('this.dataRevenuTopsellerOrders----------',this.dataRevenuTopsellerOrders)
             }else this.dataRevenuTopsellerOrders=[];
              this.typedate=res.content.field;
        }else if(filters.action=="toptraits") {
          this.dataOrdersTopTraits={series:[],sellers:[]};
          console.log('res.content toptraits----------',res.content)
          this.dataOrdersTopTraits=res.content;
        }else{
        if (filters.action == "revenu"){
          // res.content.sort(
          //   (a, b) => a._id[this.getTymeType()] - b._id[this.getTymeType()]
          // );
         } else if (filters.action == "expeditions")
          res.content.sort(
            (a, b) =>
              a._id[this.getTymeTypeExp()] - b._id[this.getTymeTypeExp()]
          );
        else{
          if (filters.action != "topproducts" && filters.action != "toptraits")  res.content.sort((a, b) =>a._id[this.getTymeTypeStock()] - b._id[this.getTymeTypeStock()]);
        }
         if (filters.action == "revenu") {  
            this.dataRevenu=res.content.total_revenus;
            this.dataRevenuOrders=res.content.total_revenus_orders;
            this.countOrders=res.content.countOrders;
            if (this.timeserch == "today") {
              this.labelsrevenu=this.labels;
            } else if (this.timeserch == "thisyear") {
              this.labelsrevenu=this.labelsMonths;
            }else if (this.timeserch == "thisweek" || this.timeserch == "lastweek") {
              this.labelsrevenu=res.content.label;
            } else if (this.timeserch == "betweendate") {
              this.labelsrevenu=res.content.label;
              if(res.content.countMonths>1){
                 for(let i in this.labelsrevenu){
                    this.labelsrevenu[i]=this.GetMonthName(this.labelsrevenu[i]);
                 }
              }
            }else {
              let nbrjours = this.getNumberOfMonths();
              for (let i = 1; i <= nbrjours; i++) {
                this.labelsrevenu.push(i);
              }
            }
         }
        if (filters.action != "revenu") {   
          for (const element of res.content) {
          if (filters.action == "stockhistories") {
              this.dataStock.push(element.quantityInStock);
              if (this.timeserchStock == "today") {
                this.labelsStock.push(("0" + element._id.hour).slice(-2));
              } else if (this.timeserchStock == "thisyear") {
                this.labelsStock.push(this.GetMonthName(element._id.month));
              } else {
                this.labelsStock.push(("0" + element._id.day).slice(-2));
              }
            } if (filters.action == "expeditions") {
              this.dataExpFees.push(element.transport_fees);
              this.dataExp.push(element.count);
              if (this.timeserch == "today") {
                this.labelsExp.push(("0" + element._id.hour).slice(-2));
              } else if (this.timeserch == "thisyear") {
                this.labelsExp.push(this.GetMonthName(element._id.month));
              } else {
                this.labelsExp.push(("0" + element._id.day).slice(-2));
              }
            }
          }
        }
        for(let j in this.dataRevenuOrders){
          this.sumrevenuorder+=this.dataRevenuOrders[j];
        }
         for(let j in this.dataRevenu){
          this.sumrevenus+=this.dataRevenu[j];
        }
       } 
      } else {
        if (filters.action == "revenu") {
          this.dataRevenu = [];
          this.dataRevenuOrders = [];
          this.sumrevenuorder=this.sumrevenus=0;
          this.countOrders=0;
          this.labelsrevenu = [];
        }
        if (filters.action == "expeditions") {
          this.dataExp = [];
          this.dataExpFees = [];
          this.labelsExp = [];
        }
      }
    },

    async getNumberOfOrders(filters) {
      const res = await this.$server.getNumberOfOrders("analytics", filters);
      this.tabordersbystatus = res.content;
    },
    getNumberOfMonths() {
      let today = new Date();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();

      let nbr_jours = new Date(year, month, 0).getDate();
      this.labels = [];
      return nbr_jours;
    },

    getNumberOfDaysLastMonths() {
      let today = new Date();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();
      let nbr_jours;
      if (month == 1) {
        nbr_jours = new Date(year - 1, 12, 0).getDate();
      } else {
        nbr_jours = new Date(year, month - 1, 0).getDate();
      }
      this.labels = [];
      return nbr_jours;
    },

    async getOrdersBetweenTwoDate() {
      const data = {
        startDate: this.formData.startDate,
        endDate: this.formData.endDate,
      };
      if (
        this.formData.startDate != undefined &&
        this.formData.endDate != undefined
      ) {
        const res = await this.$server.getOrdersBetweenTwoDate(
          "analytics",
          data
        );
        this.duree = "";
        this.duree = "Two Date";
        return res.content;
      }
    },

    /****************************************************Delivery ***********************************/
    async ChangeTypeDateDelivery(event) {
      this.timeserchdelivery = event.target.value;
      console.log('shipping status durre---',event.target.value)
      if(event.target.value != "betweendate"){
          this.labelsdelivery = [];
          await this.getTotalDelivery({DateType: event.target.value,seller:this.seller_sh?this.seller_sh._id||this.seller_sh:null,product:this.product_sh?this.product_sh._id||this.product_sh:null});
       }

    },

    async getTotalDelivery(filters) {
      this.loadingDeliverystatu=true;
      filters.warehouse=this.idWharhouse._id;
      if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters.warehouseParent=this.sous_idWharhouse;
      const res = await this.$server.getTotalDelivery("analytics", filters);
      console.log('getTotalDelivery ---',res)
      this.loadingDeliverystatu=false;
      if (res && res.content) {
          this.datadelivery = [];
          this.datadelivery = res.content.status;
           this.datadelivery.forEach(item => {
          if(item.name=="queued") {item.gradient='#e2e79d';item.colors="#e2e97a";}
          if(item.name=="received") {item.gradient='#4493d7';item.colors="#137ad3";}
          if(item.name=="prepared") {item.gradient='#2575fc';item.colors="#6a11cb";}
          if(item.name=="shipped") {item.gradient='#f7971e';item.colors="#f7971e";}
          if(item.name=="Shipped Daily") {item.gradient='#ef9a5e';item.colors="#eb7d30";}
          if(item.name=="paid") {item.gradient='#65c554';item.colors="#23ad0a";}
          if(item.name=="cancelled") {item.gradient='#e94d7d';item.colors="#f12564";}
          if(item.name=="reprogrammed") {item.gradient='#1c1c1c';item.colors="#000";}
          if(item.name=="processed") {item.gradient='#e505be';item.colors="#bb07e9";}
        });
        this.totalShippings = res.content.countAll;
      }else { this.totalShippings=0;this.datadelivery=[{name:"queued",count:0,gradient:"#e2e79d",colors:"#e2e97a"},{name:"prepared",count:0,gradient:"#2575fc",colors:"#6a11cb"},{name:"reprogrammed",count:0,gradient:"#1c1c1c",colors:"#000"},{name:"shipped",count:0,gradient:"#f7971e",colors:"#ffd200"},{name:"Shipped Daily",count:0,gradient:"#ef9a5e",colors:"#eb7d30"},{name:"received",count:0,gradient:"#4493d7",colors:"#137ad3"},{name:"paid",count:0,gradient:"#65c554",colors:"#23ad0a"},{name:"cancelled",count:0,gradient:"#e94d7d",colors:"#f12564"},{name:"processed",count:0,gradient:"#e505be",colors:"#bb07e9"}];}
    },
    async ChangeSellerDelivery(seller) {
      this.timeserchsellerdelivery = seller._id;
      this.datadelivery = [];

      await this.getTotalDelivery({
        DateType: this.timeserchdelivery,
        Seller: this.timeserchsellerdelivery,
      });
    },

    /**********************************************Fin Delivery ***********************************/

    /***********************************************Debut Confirmation Status *********************/

    async ChangeTypeDateConfirmation(event) {
      this.timeserchc = event.target.value;
    if( event.target.value != "betweendate"){
          this.dataconfirmation = [];
          if (event.target.value == "today") {
            this.labelconfirmationString = "Hours";
          } else if (event.target.value == "thisyear") {
            this.labelconfirmationString = "Months";
          } else {
            this.labelconfirmationString = "Days";
          }

          await this.getConfirmationStatus({
            DateType: event.target.value,
          });
     }
    },

    async getConfirmationStatus(filters) {
      filters.Seller = this.timeserchsellerconfirmation;
      const res = await this.$server.getConfirmationStatus(
        "analytics",
        filters
      );

      if (res.content) {
        this.dataconfirmation = res.content.status;
        this.countConfirmations = res.content.countAll;
      }
    },
    async ChangeSellerConfirmation(seller) {
      this.timeserchsellerconfirmation = seller._id;

      console.log(
        "HIII je suis  this.timeserchsellerconfirmation ",
        this.timeserchsellerconfirmation
      );
      this.dataconfirmation = [];

      await this.getConfirmationStatus({
        DateType: this.timeserchc,
        Seller: this.timeserchsellerconfirmation,
      });
    },

    /**********************************************Fin Confirmation Status ***********************************/
    /***********************************************Total Seller  **********************************************/
    async ChangeTypeDateAllSeller(event) {
      this.timeserchs = event.target.value;
      if( event.target.value != "betweendate"){
          this.dataAllSeller = [];
          if (event.target.value == "today") {
            this.labelAllsellerString = "Hours";
          } else if (event.target.value == "thisyear") {
            this.labelAllsellerString = "Months";
          } else {
            this.labelAllsellerString = "Days";
          }

          await this.getAllSeller({
            DateType: event.target.value,
          });
      }
    },

    async getAllSeller(filters) {
      const res = await this.$server.getAllSeller("analytics", filters);
      if (res.content) {
          this.dataAllSeller = res.content.status;
          this.countSellers= res.content.countAll;
      }
    },

    /***********************************************Fin total Seller **********************************/

    /**********************************************Total Orders ***************************************/

    async ChangeTypeDateOrders(event) {
      this.timesercho = event.target.value;
      if( event.target.value != "betweendate"){
      this.dataorders = [];
      this.labels = [];
      if (event.target.value == "today") {
        this.labelordersString = "Hours";
        if (this.timesercho == "today") {
          this.labels = [
            "00:00",
            "01:00",
            "02:00",
            "03:00",
            "04:00",
            "05:00",
            "06:00",
            "07:00",
            "08:00",
            "09:00",
            "10:00",
            "11:00",
            "12:00",
            "13:00",
            "14:00",
            "15:00",
            "16:00",
            "17:00",
            "18:00",
            "19:00",
            "20:00",
            "21:00",
            "22:00",
            "23:00",
          ];
        }
      } else if (event.target.value == "thismonth") {
        this.labelordersString = "Days";
        if (this.timesercho == "thismonth") {
          let nbrjours = this.getNumberOfMonths();
          for (let i = 1; i <= nbrjours; i++) {
            this.labels.push(i);
          }
        }
      } else {
        this.labelordersString = "Months";
        this.labels = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
      }
    
      await this.getOrders({
        DateType: event.target.value,
        Seller: this.timeserchsellerorders,
      });
      }
    },

    async getOrders(filters) {
      filters.Seller = this.timeserchsellerorders;
      const res = await this.$server.getOrders("analytics", filters);
     console.log('ooooooooooook order');
     if (res.content) {
        if(filters.DateType=='betweendate') {
          this.dataorders = res.content.total_orders;
          this.labels=res.content.label
          if(res.content.countMonths>1) {
             for(let i in this.labels){
                this.labels[i]=this.GetMonthName(this.labels[i]);
             }
          }
          else this.labels=res.content.label
        }
        else this.dataorders = res.content;
        console.log('dataorders',this.dataorders)
      }
    },
    async ChangeSellerOrders(seller) {
      this.timeserchsellerorders = seller._id;
      this.dataorders = [];

      await this.getOrders({
        DateType: this.timesercho,
        Seller: this.timeserchsellerorders,
      });
    },
    /***********************************************Fin total Orders **********************************/
  },
};
</script>


<style>
/* ========== MODERNIZE DASHBOARD STYLES ========== */

.home-dash .card-header .intro-y span{
  text-transform: uppercase;
}
.highcharts-credits{
  display: none;
}
.box——1{
  flex-grow: 1;
  flex-direction: column;
  display: flex;
}

.ww-45{
  width:45%;
}
.www-1\/5 {
    width: 5%;
}
.www-3\/7 {
    width: 31%;
}
.www-1\/7 {
   width: 9%;
}
  .www-90{
    width: 90%;
  }
  .www-10{
    width: 10%;
  }
.vs__dropdown-toggle {
  border: none;
}
.icon::after {
  content: "";
  display: block;
  position: absolute;
  border-top: 23px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 12px solid #3182ce;
  left: 100%;
  top: 0;
}
.ww-3\/7{
  width:45%
}
.ww-1\/7{
  width:10%
}
.wwww-1\/7{
  width:4%
}
.h-350-px {
  height: 350px;
}
.bg-transparent {
  background-color: transparent !important;
}

/* ===== GLOBAL CARD REDESIGN ===== */
.card {
  margin-bottom: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  background-color: #ffffff;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: initial;
  border-radius: 16px;
  flex: 1 1 auto;
  min-height: 1px;
  transition: all 0.3s ease;
}
.card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.card-header {
  padding: 18px 24px;
  margin-bottom: 0;
  background: transparent;
  border-bottom: 1px solid #f1f5f9;
  font-weight: 600;
  font-size: 16px;
  color: #1e293b;
  border-radius: 16px 16px 0 0;
}
.card-header:first-child {
  border-radius: 16px 16px 0 0;
}
.card-header .intro-y {
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 20px 24px;
}

/* ===== STAT CARDS (V2) REDESIGN ===== */
.statistics-box {
  background: #ffffff !important;
  background-image: none !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;
  border: none !important;
  border-radius: 16px !important;
  overflow: hidden;
  position: relative;
  padding: 20px !important;
  transition: all 0.3s ease;
  border-left: 4px solid transparent !important;
}
.statistics-box:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-2px);
}
.statistics-box:before,
.statistics-box:after {
  display: none !important;
}

/* Colored left borders per card */
.box——1:nth-child(1) .statistics-box { border-left-color: #667eea !important; }
.box——1:nth-child(2) .statistics-box { border-left-color: #13deb9 !important; }
.box——1:nth-child(3) .statistics-box { border-left-color: #ffae1f !important; }
.box——1:nth-child(4) .statistics-box { border-left-color: #4285f4 !important; }

.statistics-box .ico-icon {
  max-width: 52px;
}
.statistics-box .img-size {
  width: 52px !important;
  height: 52px !important;
  border-radius: 14px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}
.statistics-box .stats {
  margin-left: 68px;
}
.statistics-box .stats h3 {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
  margin-bottom: 4px;
}
.statistics-box .stats h3 sup {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}
.statistics-box .stats .text {
  color: #94a3b8 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.statistics-box .filter-confirm {
  width: 100px;
}
.statistics-box .filter-confirm label {
  display: none;
}
.statistics-box .filter-confirm select {
  font-size: 11px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 5px 8px;
  background: #f8fafc;
  color: #475569;
  font-weight: 500;
}
.statistics-box .border-l-2 {
  border-color: #4285f4 !important;
  background: #f0f6ff;
  border-radius: 6px;
  padding: 4px 8px !important;
  margin-top: 6px !important;
}

/* ===== LIST GROUP REDESIGN ===== */
.list-group-item {
  position: relative;
  display: block;
  padding: 12px 20px;
  color: #374151;
  border: none;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}
.list-group-item:last-child {
  border-bottom: none;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

/* ===== CIRCLE RANGE INDICATORS ===== */
.circle-range {
  width: 14px;
  height: 14px;
  background: #fff;
  border: 5px solid;
  border-radius: 50%;
  margin-right: 10px;
}

/* ===== FILTER SECTIONS ===== */
.home-dash .border-dashed {
  border: 1px dashed #cbd5e1 !important;
  border-radius: 10px;
  padding: 10px !important;
  background: #f8fafc;
  border-color: #94a3b8 !important;
}

/* ===== ANALYTICS ICON BADGES ===== */
.card-header .analytics-img {
  padding: 6px;
  background: #f0f6ff;
  border-radius: 10px;
}

/* ===== V-SELECT IN DASHBOARD ===== */
.home-dash .vs__search::placeholder {
  color: #94a3b8;
  font-size: 12px;
}
.home-dash .vs__dropdown-toggle {
  border: none !important;
  border-radius: 8px;
  min-height: 32px;
}
.home-dash .vs__selected {
  font-size: 12px;
  color: #334155;
}

/* ===== DATE PICKER IN DASHBOARD ===== */
.home-dash .mx-datepicker {
  border-radius: 8px !important;
}
.home-dash .mx-input {
  border-radius: 8px !important;
  border: 1px solid #e2e8f0 !important;
  font-size: 12px !important;
  height: 34px !important;
}

/* ===== SEARCH BUTTON ===== */
.home-dash .bg-gray-900 {
  background-color: #4285f4 !important;
  border-radius: 8px !important;
  transition: background 0.2s;
}
.home-dash .bg-gray-900:hover {
  background-color: #3367d6 !important;
}

/* ===== REFRESH OVERLAY ===== */
.vld-overlay-refrech {
  border-radius: 16px;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 8;
  overflow: hidden;
}
.vld-overlay-refrech button {
  position: relative;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 600;
  color: #4285f4;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.vld-overlay-refrech .vld-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  opacity: 0.7;
  border-radius: 16px;
}

/* Ensure cards contain their overlays */
.statistics-box,
.card,
.v4-card,
.v5-card {
  position: relative;
  overflow: hidden;
}

/* ===== FONTSIZE HELPERS ===== */
.fontsize-11 {
  font-size: 12px !important;
  color: #475569;
  padding: 3px 0;
  line-height: 1.4;
}
.fontsize-11 .w-2 {
  width: 10px !important;
  height: 10px !important;
}
.fontsize-11 .font-medium {
  font-weight: 600 !important;
  color: #1e293b;
}

/* ===== WELCOME BANNER ===== */
.welcome-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #eef2ff;
  border-radius: 16px;
  padding: 28px 32px;
  margin: 0 8px 20px;
  overflow: hidden;
  position: relative;
}
.welcome-content {
  flex: 1;
  min-width: 0;
}
.welcome-title {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 6px;
}
.welcome-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0 0 20px;
}
.welcome-stats {
  display: flex;
  align-items: center;
  gap: 0;
}
.welcome-stat {
  display: flex;
  flex-direction: column;
}
.welcome-stat-value {
  font-size: 26px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}
.welcome-stat-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}
.welcome-stat-divider {
  width: 1px;
  height: 40px;
  background: #cbd5e1;
  margin: 0 24px;
}
.welcome-stat-skeleton {
  display: block;
  width: 80px;
  height: 28px;
  background: linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  border-radius: 6px;
  animation: skeleton-pulse 1.5s ease-in-out infinite;
}
@keyframes skeleton-pulse {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
.welcome-img {
  flex-shrink: 0;
  margin-left: 20px;
}
.welcome-img img {
  height: 160px;
  object-fit: contain;
}
@media (max-width: 768px) {
  .welcome-banner {
    flex-direction: column;
    text-align: center;
    padding: 20px;
  }
  .welcome-img {
    margin-left: 0;
    margin-top: 16px;
  }
  .welcome-img img {
    height: 100px;
  }
  .welcome-stats {
    justify-content: center;
  }
  .welcome-title {
    font-size: 18px;
  }
}

/* ===== LAYOUT SPACING ===== */
.home-dash {
  padding: 0 8px;
}
.home-dash .flex-wrap {
  gap: 0;
}
.home-dash .box——1 {
  padding-left: 8px !important;
  padding-right: 8px !important;
  margin-bottom: 16px !important;
}

.align-items-center {
  align-items: center !important;
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
.text-light {
  color: #ced4da !important;
}
.ls-1 {
  letter-spacing: 0.0625rem;
}
.justify-content-end {
  justify-content: flex-end !important;
}
.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.nav-pills .nav-item:not(:last-child) {
  padding-right: 1rem;
}
.nav-pills .nav-link {
  padding: 0.75rem 1rem;
  color: #4285f4;
  font-weight: 500;
  font-size: 0.875rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  background-color: #fff;
  transition: all 0.15s ease;
  border-radius: 8px;
}
.d-md-block {
  display: block !important;
}
.analytics-img{
  vertical-align: middle;
  display: inline-block;
  width: 28px;
}
.vld-overlay-refrech {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    align-items: center;
    display: flex;
    justify-content: center;
    overflow: hidden;
    z-index: 8;
    cursor: pointer;
}
.vld-overlay-refrech button{
  position: relative;
  background: #fff;
}
.vld-overlay-refrech .vld-background {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    background: #fff;
    opacity: 0.5;
}
.analytics-imgg{
  vertical-align: middle;
  display: inline-block;
  width: 30px;
  padding-right: 5px;
}
.col {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.highcharts-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  text-align: left;
  line-height: normal;
  z-index: 0;
  /* #1072 */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-family: "Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif;
  font-size: 12px;
}

.toptraits .highcharts-color-5 {
    fill: #08a60d;
    stroke: #08a60dc9;
}
.toptraits .highcharts-color-4 {
    fill: #d93609;
    stroke: #ac2703;
}
.toptraits .highcharts-color-1 {
    fill: black;
    stroke: black;
}
.toptraits  .highcharts-color-2 {
    fill: #e9ae63;
    stroke: #e99c39;
}
.toptraits  .highcharts-color-3 {
    fill: #ec5ee0;
    stroke: #b20da4;
}

.highcharts-root {
  display: block;
}

.highcharts-root text {
  stroke-width: 0;
}

.highcharts-strong {
  font-weight: bold;
}

.highcharts-emphasized {
  font-style: italic;
}

.highcharts-anchor {
  cursor: pointer;
}

.highcharts-background {
  fill: #ffffff;
}

.highcharts-plot-border, .highcharts-plot-background {
  fill: none;
}

.highcharts-label-box {
  fill: none;
}

.highcharts-button-box {
  fill: inherit;
}

.highcharts-tracker-line {
  stroke-linejoin: round;
  stroke: rgba(192, 192, 192, 0.0001);
  stroke-width: 22;
  fill: none;
}

.highcharts-tracker-area {
  fill: rgba(192, 192, 192, 0.0001);
  stroke-width: 0;
}

/* Titles */
.highcharts-title {
  fill: #333333;
  font-size: 1.5em;
}

.highcharts-subtitle {
  fill: #666666;
}

/* Axes */
.highcharts-axis-line {
  fill: none;
  stroke: #ccd6eb;
}

.highcharts-yaxis .highcharts-axis-line {
  stroke-width: 0;
}

.highcharts-axis-title {
  fill: #666666;
}

.highcharts-axis-labels {
  fill: #666666;
  cursor: default;
  font-size: 0.9em;
}

.highcharts-grid-line {
  fill: none;
  stroke: #e6e6e6;
}

.highcharts-xaxis-grid .highcharts-grid-line {
  stroke-width: 0px;
}

.highcharts-tick {
  stroke: #ccd6eb;
}

.highcharts-yaxis .highcharts-tick {
  stroke-width: 0;
}

.highcharts-minor-grid-line {
  stroke: #f2f2f2;
}

.highcharts-crosshair-thin {
  stroke-width: 1px;
  stroke: #cccccc;
}

.highcharts-crosshair-category {
  stroke: #ccd6eb;
  stroke-opacity: 0.25;
}

/* Credits */
.highcharts-credits {
  cursor: pointer;
  fill: #999999;
  font-size: 0.7em;
  transition: fill 250ms, font-size 250ms;
}

.highcharts-credits:hover {
  fill: black;
  font-size: 1em;
}

/* Tooltip */
.highcharts-tooltip {
  cursor: default;
  pointer-events: none;
  white-space: nowrap;
  transition: stroke 150ms;
}

.highcharts-tooltip text {
  fill: #333333;
}

.highcharts-tooltip .highcharts-header {
  font-size: 0.85em;
}

.highcharts-tooltip-box {
  stroke-width: 1px;
  fill: #f7f7f7;
  fill-opacity: 0.85;
}

.highcharts-tooltip-box .highcharts-label-box {
  fill: #f7f7f7;
  fill-opacity: 0.85;
}

div.highcharts-tooltip {
  filter: none;
}

.highcharts-selection-marker {
  fill: #335cad;
  fill-opacity: 0.25;
}

.highcharts-graph {
  fill: none;
  stroke-width: 2px;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.highcharts-state-hover .highcharts-graph {
  stroke-width: 3;
}

.highcharts-point-inactive {
  opacity: 0.2;
  transition: opacity 50ms;
  /* quick in */
}

.highcharts-series-inactive {
  opacity: 0.2;
  transition: opacity 50ms;
  /* quick in */
}

.highcharts-state-hover path {
  transition: stroke-width 50ms;
  /* quick in */
}

.highcharts-state-normal path {
  transition: stroke-width 250ms;
  /* slow out */
}

/* Legend hover affects points and series */
g.highcharts-series,
.highcharts-point,
.highcharts-markers,
.highcharts-data-labels {
  transition: opacity 250ms;
}

.highcharts-legend-series-active g.highcharts-series:not(.highcharts-series-hover),
.highcharts-legend-point-active .highcharts-point:not(.highcharts-point-hover),
.highcharts-legend-series-active .highcharts-markers:not(.highcharts-series-hover),
.highcharts-legend-series-active .highcharts-data-labels:not(.highcharts-series-hover) {
  opacity: 0.2;
}

/* Series options */
/* Default colors */
.highcharts-color-0 {
  fill: #0d6efd;
  stroke: #0d6efd;
}

.highcharts-color-1 {
  fill: #f41127;
  stroke: #f41127;
}

.highcharts-color-2 {
  fill: #ffc107;
  stroke: #ffc107;
}

.highcharts-color-3 {
  fill: #17a00e;
  stroke: #17a00e;
}

.highcharts-color-4 {
  fill: #212529;
  stroke: #212529;
}

.highcharts-color-5 {
  fill: #0dcaf0;
  stroke: #0dcaf0;
}

.highcharts-color-6 {
  fill: #607d8b;
  stroke: #607d8b;
}

.highcharts-color-7 {
  fill: #ee14e0;
  stroke: #ee14e0;
}

.highcharts-color-8 {
  fill: #01dec9;
  stroke: #01dec9;
}

.highcharts-color-9 {
  fill: rgb(0 0 0 / 7%);
    stroke: rgb(62 62 62 / 7%);
}

.highcharts-area {
  fill-opacity: 0.75;
  stroke-width: 0;
}

.highcharts-markers {
  stroke-width: 1px;
  stroke: #ffffff;
}

.highcharts-point {
  stroke-width: 1px;
}

.highcharts-dense-data .highcharts-point {
  stroke-width: 0;
}

.highcharts-data-label {
  font-size: 0.9em;
  font-weight: bold;
}

.highcharts-data-label-box {
  fill: none;
  stroke-width: 0;
}

.highcharts-data-label text, text.highcharts-data-label {
  fill: #333333;
}

.highcharts-data-label-connector {
  fill: none;
}

.highcharts-data-label-hidden {
  pointer-events: none;
}

.highcharts-halo {
  fill-opacity: 0.25;
  stroke-width: 0;
}

.highcharts-series:not(.highcharts-pie-series) .highcharts-point-select,
.highcharts-markers .highcharts-point-select {
  fill: #cccccc;
  stroke: #000000;
}

.highcharts-column-series rect.highcharts-point {
  stroke: #ffffff;
}

.highcharts-column-series .highcharts-point {
  transition: fill-opacity 250ms;
}

.highcharts-column-series .highcharts-point-hover {
  fill-opacity: 0.75;
  transition: fill-opacity 50ms;
}

.highcharts-pie-series .highcharts-point {
  stroke-linejoin: round;
  stroke: #ffffff;
}

.highcharts-pie-series .highcharts-point-hover {
  fill-opacity: 0.75;
  transition: fill-opacity 50ms;
}

.highcharts-funnel-series .highcharts-point {
  stroke-linejoin: round;
  stroke: #ffffff;
}

.highcharts-funnel-series .highcharts-point-hover {
  fill-opacity: 0.75;
  transition: fill-opacity 50ms;
}

.highcharts-funnel-series .highcharts-point-select {
  fill: inherit;
  stroke: inherit;
}

.highcharts-pyramid-series .highcharts-point {
  stroke-linejoin: round;
  stroke: #ffffff;
}

.highcharts-pyramid-series .highcharts-point-hover {
  fill-opacity: 0.75;
  transition: fill-opacity 50ms;
}

.highcharts-pyramid-series .highcharts-point-select {
  fill: inherit;
  stroke: inherit;
}

.highcharts-solidgauge-series .highcharts-point {
  stroke-width: 0;
}

.highcharts-treemap-series .highcharts-point {
  stroke-width: 1px;
  stroke: #e6e6e6;
  transition: stroke 250ms, fill 250ms, fill-opacity 250ms;
}

.highcharts-treemap-series .highcharts-point-hover {
  stroke: #999999;
  transition: stroke 25ms, fill 25ms, fill-opacity 25ms;
}

.highcharts-treemap-series .highcharts-above-level {
  display: none;
}

.highcharts-treemap-series .highcharts-internal-node {
  fill: none;
}

.highcharts-treemap-series .highcharts-internal-node-interactive {
  fill-opacity: 0.15;
  cursor: pointer;
}

.highcharts-treemap-series .highcharts-internal-node-interactive:hover {
  fill-opacity: 0.75;
}

.highcharts-vector-series .highcharts-point {
  fill: none;
  stroke-width: 2px;
}

.highcharts-windbarb-series .highcharts-point {
  fill: none;
  stroke-width: 2px;
}

.highcharts-lollipop-stem {
  stroke: #000000;
}

.highcharts-focus-border {
  fill: none;
  stroke-width: 2px;
}

.highcharts-legend-item-hidden .highcharts-focus-border {
  fill: none !important;
}

/* Legend */
.highcharts-legend-box {
  fill: none;
  stroke-width: 0;
}

.highcharts-legend-item > text {
  fill: #333333;
  font-weight: bold;
  font-size: 1em;
  cursor: pointer;
  stroke-width: 0;
}

.highcharts-legend-item:hover text {
  fill: #000000;
}

.highcharts-legend-item-hidden * {
  fill: #cccccc !important;
  stroke: #cccccc !important;
  transition: fill 250ms;
}

.highcharts-legend-nav-active {
  fill: #003399;
  cursor: pointer;
}

.highcharts-legend-nav-inactive {
  fill: #cccccc;
}

circle.highcharts-legend-nav-active, circle.highcharts-legend-nav-inactive {
  /* tracker */
  fill: rgba(192, 192, 192, 0.0001);
}

.highcharts-legend-title-box {
  fill: none;
  stroke-width: 0;
}

/* Bubble legend */
.highcharts-bubble-legend-symbol {
  stroke-width: 2;
  fill-opacity: 0.5;
}

.highcharts-bubble-legend-connectors {
  stroke-width: 1;
}

.highcharts-bubble-legend-labels {
  fill: #333333;
}

/* Loading */
.highcharts-loading {
  position: absolute;
  background-color: #ffffff;
  opacity: 0.5;
  text-align: center;
  z-index: 10;
  transition: opacity 250ms;
}

.highcharts-loading-hidden {
  height: 0 !important;
  opacity: 0;
  overflow: hidden;
  transition: opacity 250ms, height 250ms step-end;
}

.highcharts-loading-inner {
  font-weight: bold;
  position: relative;
  top: 45%;
}

/* Plot bands and polar pane backgrounds */
.highcharts-plot-band, .highcharts-pane {
  fill: #000000;
  fill-opacity: 0.05;
}

.highcharts-plot-line {
  fill: none;
  stroke: #999999;
  stroke-width: 1px;
}

/* Highcharts More and modules */
.highcharts-boxplot-box {
  fill: #ffffff;
}

.highcharts-boxplot-median {
  stroke-width: 2px;
}

.highcharts-bubble-series .highcharts-point {
  fill-opacity: 0.5;
}

.highcharts-errorbar-series .highcharts-point {
  stroke: #000000;
}

.highcharts-gauge-series .highcharts-data-label-box {
  stroke: #cccccc;
  stroke-width: 1px;
}

.highcharts-gauge-series .highcharts-dial {
  fill: #000000;
  stroke-width: 0;
}

.highcharts-polygon-series .highcharts-graph {
  fill: inherit;
  stroke-width: 0;
}

.highcharts-waterfall-series .highcharts-graph {
  stroke: #333333;
  stroke-dasharray: 1, 3;
}

.highcharts-sankey-series .highcharts-point {
  stroke-width: 0;
}

.highcharts-sankey-series .highcharts-link {
  transition: fill 250ms, fill-opacity 250ms;
  fill-opacity: 0.5;
}

.highcharts-sankey-series .highcharts-point-hover.highcharts-link {
  transition: fill 50ms, fill-opacity 50ms;
  fill-opacity: 1;
}

.highcharts-venn-series .highcharts-point {
  fill-opacity: 0.75;
  stroke: #cccccc;
  transition: stroke 250ms, fill-opacity 250ms;
}

.highcharts-venn-series .highcharts-point-hover {
  fill-opacity: 1;
  stroke: #cccccc;
}

/* Highstock */
.highcharts-navigator-mask-outside {
  fill-opacity: 0;
}

.highcharts-navigator-mask-inside {
  fill: #6685c2;
  /* navigator.maskFill option */
  fill-opacity: 0.25;
  cursor: ew-resize;
}

.highcharts-navigator-outline {
  stroke: #cccccc;
  fill: none;
}

.highcharts-navigator-handle {
  stroke: #cccccc;
  fill: #f2f2f2;
  cursor: ew-resize;
}

.highcharts-navigator-series {
  fill: #335cad;
  stroke: #335cad;
}

.highcharts-navigator-series .highcharts-graph {
  stroke-width: 1px;
}

.highcharts-navigator-series .highcharts-area {
  fill-opacity: 0.05;
}

.highcharts-navigator-xaxis .highcharts-axis-line {
  stroke-width: 0;
}

.highcharts-navigator-xaxis .highcharts-grid-line {
  stroke-width: 1px;
  stroke: #e6e6e6;
}

.highcharts-navigator-xaxis.highcharts-axis-labels {
  fill: #999999;
}

.highcharts-navigator-yaxis .highcharts-grid-line {
  stroke-width: 0;
}

.highcharts-scrollbar-thumb {
  fill: #cccccc;
  stroke: #cccccc;
  stroke-width: 1px;
}

.highcharts-scrollbar-button {
  fill: #e6e6e6;
  stroke: #cccccc;
  stroke-width: 1px;
}

.highcharts-scrollbar-arrow {
  fill: #666666;
}

.highcharts-scrollbar-rifles {
  stroke: #666666;
  stroke-width: 1px;
}

.highcharts-scrollbar-track {
  fill: #f2f2f2;
  stroke: #f2f2f2;
  stroke-width: 1px;
}

.highcharts-button {
  fill: #f7f7f7;
  stroke: #cccccc;
  cursor: default;
  stroke-width: 1px;
  transition: fill 250ms;
}

.highcharts-button text {
  fill: #333333;
}

.highcharts-button-hover {
  transition: fill 0ms;
  fill: #e6e6e6;
  stroke: #cccccc;
}

.highcharts-button-hover text {
  fill: #333333;
}

.highcharts-button-pressed {
  font-weight: bold;
  fill: #e6ebf5;
  stroke: #cccccc;
}

.highcharts-button-pressed text {
  fill: #333333;
  font-weight: bold;
}

.highcharts-button-disabled text {
  fill: #333333;
}

.highcharts-range-selector-buttons .highcharts-button {
  stroke-width: 0px;
}

.highcharts-range-label rect {
  fill: none;
}

.highcharts-range-label text {
  fill: #666666;
}

.highcharts-range-input rect {
  fill: none;
}

.highcharts-range-input text {
  fill: #333333;
}

.highcharts-range-input {
  stroke-width: 1px;
  stroke: #cccccc;
}

input.highcharts-range-selector {
  position: absolute;
  border: 0;
  width: 1px;
  /* Chrome needs a pixel to see it */
  height: 1px;
  padding: 0;
  text-align: center;
  left: -9em;
  /* #4798 */
}

.highcharts-crosshair-label text {
  fill: #ffffff;
  font-size: 1.1em;
}

.highcharts-crosshair-label .highcharts-label-box {
  fill: inherit;
}

.highcharts-candlestick-series .highcharts-point {
  stroke: #000000;
  stroke-width: 1px;
}

.highcharts-candlestick-series .highcharts-point-up {
  fill: #ffffff;
}

.highcharts-ohlc-series .highcharts-point-hover {
  stroke-width: 3px;
}

.highcharts-flags-series .highcharts-point .highcharts-label-box {
  stroke: #999999;
  fill: #ffffff;
  transition: fill 250ms;
}

.highcharts-flags-series .highcharts-point-hover .highcharts-label-box {
  stroke: #000000;
  fill: #ccd6eb;
}

.highcharts-flags-series .highcharts-point text {
  fill: #000000;
  font-size: 0.9em;
  font-weight: bold;
}

/* Highmaps */
.highcharts-map-series .highcharts-point {
  transition: fill 500ms, fill-opacity 500ms, stroke-width 250ms;
  stroke: #cccccc;
}

.highcharts-map-series .highcharts-point-hover {
  transition: fill 0ms, fill-opacity 0ms;
  fill-opacity: 0.5;
  stroke-width: 2px;
}

.highcharts-mapline-series .highcharts-point {
  fill: none;
}

.highcharts-heatmap-series .highcharts-point {
  stroke-width: 0;
}

.highcharts-map-navigation {
  font-size: 1.3em;
  font-weight: bold;
  text-align: center;
}

.highcharts-coloraxis {
  stroke-width: 0;
}

.highcharts-coloraxis-marker {
  fill: #999999;
}

.highcharts-null-point {
  fill: #f7f7f7;
}

/* 3d charts */
.highcharts-3d-frame {
  fill: transparent;
}

/* Exporting module */
.highcharts-contextbutton {
  fill: #ffffff;
  /* needed to capture hover */
  stroke: none;
  stroke-linecap: round;
}

.highcharts-contextbutton:hover {
  fill: #e6e6e6;
  stroke: #e6e6e6;
}

.highcharts-button-symbol {
  stroke: #666666;
  stroke-width: 3px;
}

.highcharts-menu {
  border: 1px solid #999999;
  background: #ffffff;
  padding: 5px 0;
  box-shadow: 3px 3px 10px #888;
}

.highcharts-menu-item {
  padding: 0.5em 1em;
  background: none;
  color: #333333;
  cursor: pointer;
  transition: background 250ms, color 250ms;
}

.highcharts-menu-item:hover {
  background: #335cad;
  color: #ffffff;
}

/* Drilldown module */
.highcharts-drilldown-point {
  cursor: pointer;
}

.highcharts-drilldown-data-label text,
text.highcharts-drilldown-data-label,
.highcharts-drilldown-axis-label {
  cursor: pointer;
  fill: #003399;
  font-weight: bold;
  text-decoration: underline;
}

/* No-data module */
.highcharts-no-data text {
  font-weight: bold;
  font-size: 12px;
  fill: #666666;
}

/* Drag-panes module */
.highcharts-axis-resizer {
  cursor: ns-resize;
  stroke: black;
  stroke-width: 2px;
}

/* Bullet type series */
.highcharts-bullet-target {
  stroke-width: 0;
}

/* Lineargauge type series */
.highcharts-lineargauge-target {
  stroke-width: 1px;
  stroke: #333333;
}

.highcharts-lineargauge-target-line {
  stroke-width: 1px;
  stroke: #333333;
}

/* Annotations module */
.highcharts-annotation-label-box {
  stroke-width: 1px;
  stroke: #000000;
  fill: #000000;
  fill-opacity: 0.75;
}

.highcharts-annotation-label text {
  fill: #e6e6e6;
}

/* Gantt */
.highcharts-treegrid-node-collapsed, .highcharts-treegrid-node-expanded {
  cursor: pointer;
}

.highcharts-point-connecting-path {
  fill: none;
}

.highcharts-grid-axis .highcharts-tick {
  stroke-width: 1px;
}

.highcharts-grid-axis .highcharts-axis-line {
  stroke-width: 1px;
}
/* General data label style */
.highcharts-data-label text {
    fill: black;
    text-shadow: 1px 1px white, 1px -1px white, -1px -1px white, -1px 1px white;
}

/* For the darkest columns, invert the data label text color and shadow */
.highcharts-data-label-color-0 text,
.highcharts-data-label-color-1 text,
.highcharts-data-label-color-4 text,
.highcharts-data-label-color-5 text,
.highcharts-data-label-color-7 text {
    fill: white;
    text-shadow: 1px 1px black, 1px -1px black, -1px -1px black, -1px 1px black;
}
</style>
